(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  class AccordionGroup extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('details.accordion-item'));
      this.handleToggle = this.handleToggle.bind(this);
      this.items.forEach((item) => item.addEventListener('toggle', this.handleToggle));
    }

    disconnectedCallback() {
      if (this.items) {
        this.items.forEach((item) => item.removeEventListener('toggle', this.handleToggle));
      }
    }

    // Enforce single-open even where the native `name` exclusive group is unsupported.
    // Closing a sibling here flips its `open` attribute, which runs the CSS
    // `::details-content` height transition (the auto-close animation). Where `name`
    // is supported the browser has already closed the sibling, so this is a no-op.
    handleToggle(event) {
      const opened = event.target;
      if (!opened.open) return;
      this.items.forEach((item) => {
        if (item !== opened && item.open) item.open = false;
      });
    }
  }

  if (!window.customElements.get('accordion-group')) {
    window.customElements.define('accordion-group', AccordionGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-announcement-item]'));
      if (!this.items.length) return;
      this.index = 0;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.setAttribute('data-enhanced', '');
      this.show(0);
      if (this.items.length > 1 && !this.reduceMotion.matches) {
        this.bind();
        this.play();
      }
    }

    disconnectedCallback() {
      this.stop();
      this.unbind();
    }

    bind() {
      this.handleStop = () => this.stop();
      this.handlePlay = () => this.play();
      this.handleVisibility = () => {
        if (document.hidden) {
          this.stop();
        } else {
          this.play();
        }
      };
      this.addEventListener('pointerenter', this.handleStop);
      this.addEventListener('pointerleave', this.handlePlay);
      this.addEventListener('focusin', this.handleStop);
      this.addEventListener('focusout', this.handlePlay);
      document.addEventListener('visibilitychange', this.handleVisibility);
    }

    unbind() {
      if (!this.handleStop) return;
      this.removeEventListener('pointerenter', this.handleStop);
      this.removeEventListener('pointerleave', this.handlePlay);
      this.removeEventListener('focusin', this.handleStop);
      this.removeEventListener('focusout', this.handlePlay);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    show(next) {
      this.items.forEach((item, i) => {
        const active = i === next;
        item.toggleAttribute('data-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.index = next;
    }

    advance() {
      this.show((this.index + 1) % this.items.length);
    }

    play() {
      this.stop();
      if (this.items.length < 2 || this.reduceMotion.matches) return;
      const seconds = parseFloat(this.getAttribute('data-duration')) || 3;
      this.timer = window.setInterval(() => this.advance(), seconds * 1000);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!window.customElements.get('announcement-bar')) {
    window.customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this._onAdded = this._onAdded.bind(this);
      this._onUpdated = this._onUpdated.bind(this);
      this._pauseAutoClose = this._pauseAutoClose.bind(this);
      this._resumeAutoClose = this._resumeAutoClose.bind(this);
      document.addEventListener('cart:added', this._onAdded);
      document.addEventListener('cart:updated', this._onUpdated);
      // Pointer or keyboard attention pauses the auto-dismiss (WCAG 2.2.1);
      // leaving re-arms it. Pointer listeners bind to the PANEL, not the host:
      // the host also contains the full-viewport backdrop, and a cursor merely
      // parked over the page must not freeze the timer.
      this._panel = this.querySelector('.overlay__panel');
      if (this._panel) {
        this._panel.addEventListener('pointerenter', this._pauseAutoClose);
        this._panel.addEventListener('pointerleave', this._resumeAutoClose);
      }
      this.addEventListener('focusin', this._pauseAutoClose);
      this.addEventListener('focusout', this._resumeAutoClose);
      this._watchClose();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:added', this._onAdded);
      document.removeEventListener('cart:updated', this._onUpdated);
      if (this._panel) {
        this._panel.removeEventListener('pointerenter', this._pauseAutoClose);
        this._panel.removeEventListener('pointerleave', this._resumeAutoClose);
        this._panel = null;
      }
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      this._clearTimer();
      this._bound = false;
    }

    get overlay() {
      return this.querySelector('overlay-drawer');
    }

    _onAdded(event) {
      var detail = event.detail || {};
      var self = this;
      this._swapFrom(detail.sections)
        .then(function () {
          self._syncCount();
          self._enterAddedMode(detail.variantId);
          var overlay = self.overlay;
          if (overlay && typeof overlay.open === 'function' && !overlay.isOpen) overlay.open();
          // A fresh add always (re)arms the 4s window: open() moves focus into
          // the panel programmatically, and that focusin must not count as user
          // attention (it would pause the timer before it ever armed). Real
          // attention -- hovering the panel or tabbing within it -- still pauses.
          self._paused = false;
          self._startAutoClose();
        })
        .catch(function () {
          // The add itself succeeded; a failed refresh must never break the page.
        });
    }

    _onUpdated(event) {
      var detail = event.detail || {};
      var html = detail.sections && detail.sections['cart-drawer'];
      var self = this;
      if (html) {
        this._swap(html);
        this._syncCount();
        this._reapplyFilter();
        return;
      }
      var overlay = this.overlay;
      if (overlay && overlay.isOpen) {
        this._swapFrom(null)
          .then(function () {
            self._syncCount();
            self._reapplyFilter();
          })
          .catch(function () {});
        return;
      }
      // Closed with no payload: sync the count from the response cart and skip
      // the network round-trip -- the next add delivers fresh contents anyway.
      if (detail.cart && typeof detail.cart.item_count !== 'undefined') {
        this._syncCount(detail.cart.item_count);
      }
    }

    // Resolve fresh contents from a bundled sections payload, else re-fetch via
    // the Section Rendering GET (preview/dev themes omit bundled sections from
    // cart AJAX responses). Inherit the page query string so preview sessions
    // keep their preview_theme_id.
    _swapFrom(sections) {
      var html = sections && sections['cart-drawer'];
      if (html) {
        this._swap(html);
        return Promise.resolve();
      }
      var self = this;
      var params = new URLSearchParams(window.location.search);
      params.set('sections', 'cart-drawer');
      return fetch(window.location.pathname + '?' + params.toString())
        .then(function (response) {
          return response.ok ? response.json() : Promise.reject(response);
        })
        .then(function (fetched) {
          var fetchedHtml = fetched && fetched['cart-drawer'];
          if (fetchedHtml) self._swap(fetchedHtml);
        });
    }

    _swap(html) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-contents]');
      var live = this.querySelector('[data-cart-drawer-contents]');
      if (fresh && live) live.replaceWith(fresh);
    }

    _enterAddedMode(variantId) {
      this._addedVariantId = variantId == null ? null : String(variantId);
      this._applyFilter();
    }

    _reapplyFilter() {
      if (this.hasAttribute('data-added-mode')) this._applyFilter();
    }

    _applyFilter() {
      var target = this._addedVariantId;
      var seen = { item: false, summary: false };
      var matched = false;
      this.querySelectorAll('[data-variant-id]').forEach(function (el) {
        // One variant can occupy more than one cart line (line properties split
        // them -- an upsell add tags its line `_upsell_item`), and the id is
        // carried by BOTH the item row and its Savings/Total block. Mark only
        // the first match within each group, else added mode renders duplicate
        // rows and duplicate summaries (#50). cart:added carries no line key,
        // so first-match is the closest available proxy for the added line.
        var group = el.classList.contains('cart-drawer__summary') ? 'summary' : 'item';
        var current = target != null && el.getAttribute('data-variant-id') === target && !seen[group];
        if (current) {
          seen[group] = true;
          // Only an item row arms added mode -- a summary alone would hide
          // every line and leave the drawer blank.
          if (group === 'item') matched = true;
        }
        el.toggleAttribute('data-added-current', current);
      });
      // Defensive: if the added line is missing from the swapped contents,
      // drop added mode so the drawer shows everything instead of nothing.
      this.toggleAttribute('data-added-mode', matched);
    }

    _exitAddedMode() {
      this._addedVariantId = null;
      this.removeAttribute('data-added-mode');
      this.querySelectorAll('[data-added-current]').forEach(function (el) {
        el.removeAttribute('data-added-current');
      });
    }

    _startAutoClose() {
      if (this._paused) return;
      this._clearTimer();
      var self = this;
      this._autoCloseTimer = setTimeout(function () {
        var overlay = self.overlay;
        if (overlay && typeof overlay.close === 'function') overlay.close();
      }, 4000);
    }

    _clearTimer() {
      if (this._autoCloseTimer) {
        clearTimeout(this._autoCloseTimer);
        this._autoCloseTimer = null;
      }
    }

    _pauseAutoClose() {
      this._paused = true;
      this._clearTimer();
    }

    _resumeAutoClose() {
      if (!this._paused) return;
      this._paused = false;
      var overlay = this.overlay;
      if (overlay && overlay.isOpen && this.hasAttribute('data-added-mode')) this._startAutoClose();
    }

    // Exit added mode whenever the drawer closes (X, backdrop, Escape or the
    // auto-close), whichever code path closed it -- the overlay owns those
    // handlers, so watch its open-state attribute.
    _watchClose() {
      var overlay = this.overlay;
      if (!overlay || this._observer) return;
      var self = this;
      this._observer = new MutationObserver(function () {
        if (!overlay.hasAttribute('data-open')) {
          self._clearTimer();
          self._paused = false;
          if (self.hasAttribute('data-added-mode')) self._exitAddedMode();
        }
      });
      this._observer.observe(overlay, { attributes: true, attributeFilter: ['data-open'] });
    }

    // Single owner of the header cart count: badge text (created from zero,
    // removed at zero) and the link's aria-label via the pluralised templates.
    _syncCount(count) {
      if (count == null) {
        var contents = this.querySelector('[data-cart-drawer-contents]');
        if (!contents) return;
        count = contents.getAttribute('data-cart-item-count');
      }
      count = parseInt(count, 10);
      if (isNaN(count)) return;
      var link = document.querySelector('[data-cart-link]');
      var badge = document.querySelector('[data-cart-count]');
      if (count === 0) {
        // The server-rendered header omits the badge at zero -- mirror it.
        if (badge) badge.remove();
      } else if (badge) {
        badge.textContent = count;
      } else if (link) {
        badge = document.createElement('span');
        badge.className = 'header-actions__count';
        badge.setAttribute('data-cart-count', '');
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = count;
        link.appendChild(badge);
      }
      if (link) {
        var label;
        if (count === 0) {
          label = this.dataset.labelCart;
        } else if (count === 1) {
          label = this.dataset.labelCountOne;
        } else {
          label = this.dataset.labelCountOther;
        }
        if (label) link.setAttribute('aria-label', label.replace('[[count]]', count));
      }
    }
  }

  if (!window.customElements.get('cart-drawer')) {
    window.customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.changeUrl = this.dataset.changeUrl || '/cart/change.js';
      this.timers = {};
      this.queue = Promise.resolve();
      this._onClick = this._onClick.bind(this);
      this._onChange = this._onChange.bind(this);
      this._onSubmit = this._onSubmit.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('change', this._onChange);
      this.addEventListener('submit', this._onSubmit);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('change', this._onChange);
      this.removeEventListener('submit', this._onSubmit);
      var self = this;
      Object.keys(this.timers).forEach(function (key) {
        clearTimeout(self.timers[key]);
      });
    }

    _onClick(event) {
      var dec = event.target.closest('[data-qty-decrease]');
      var inc = event.target.closest('[data-qty-increase]');
      var remove = event.target.closest('[data-cart-remove]');
      var wishlist = event.target.closest('[data-move-to-wishlist]');
      if (dec || inc) {
        event.preventDefault();
        var control = dec || inc;
        var bumpLine = control.closest('[data-cart-line]');
        this._focusHint = { key: bumpLine && bumpLine.getAttribute('data-line-key'), hook: dec ? 'data-qty-decrease' : 'data-qty-increase' };
        this._bump(bumpLine, dec ? -1 : 1);
      } else if (remove) {
        event.preventDefault();
        this._focusHint = { key: null, hook: null };
        this._change(remove.closest('[data-cart-line]'), 0);
      } else if (wishlist) {
        event.preventDefault();
        this._focusHint = { key: null, hook: null };
        this._moveToWishlist(wishlist.closest('[data-cart-line]'));
      }
    }

    _onChange(event) {
      var input = event.target.closest('[data-qty-input]');
      if (!input) return;
      var line = input.closest('[data-cart-line]');
      if (!line) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      this._focusHint = { key: line.getAttribute('data-line-key'), hook: 'data-qty-input' };
      this._change(line, qty);
    }

    // Checkout posts natively; any other submit (Enter in a quantity input
    // hitting the update fallback) is already handled by the change listener.
    _onSubmit(event) {
      if (event.submitter && event.submitter.name === 'checkout') return;
      event.preventDefault();
    }

    // Debounce the +/- taps so five fast clicks collapse into one request.
    _bump(line, delta) {
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var input = line.querySelector('[data-qty-input]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 0) + delta;
      // Minus at qty 1 removes the line: fire the removal immediately (skip the
      // debounce) so the input never flashes "0".
      if (next <= 0) {
        this._change(line, 0);
        return;
      }
      input.value = next;
      var self = this;
      if (this.timers[key]) clearTimeout(this.timers[key]);
      this.timers[key] = setTimeout(function () {
        self._change(line, next);
      }, 350);
    }

    _change(line, quantity) {
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      if (this.timers[key]) {
        clearTimeout(this.timers[key]);
        delete this.timers[key];
      }
      var input = line.querySelector('[data-qty-input]');
      if (input) input.value = quantity;
      line.setAttribute('data-pending', '');
      var self = this;
      // Serialise requests so concurrent line edits never race.
      this.queue = this.queue.then(function () {
        return self._request(key, quantity, line);
      });
    }

    // Neutral line facts for `cart:line-changed`, read from the server-rendered
    // data attributes on the row. Deliberately NOT Klaviyo's payload naming --
    // the GA4 (#18649708) and Shopify Pixel (#18649702) tickets can consume the
    // same event without a rename.
    _lineSnapshot(key, quantity, line) {
      if (!line) return null;
      var attr = function (name) {
        var value = line.getAttribute(name);
        return value === null || value === '' ? undefined : value;
      };
      return {
        type: Number(quantity) === 0 ? 'remove' : 'change',
        key: key,
        productId: attr('data-product-id'),
        variantId: attr('data-variant-id'),
        title: attr('data-line-title'),
        variantTitle: attr('data-line-variant-title'),
        price: attr('data-line-price'),
        originalPrice: attr('data-line-original-price'),
        sku: attr('data-line-sku'),
        vendor: attr('data-line-vendor'),
        category: attr('data-line-category'),
        category2: attr('data-line-category2'),
        giftCard: attr('data-line-gift-card') === 'true',
        quantity: Number(quantity),
        previousQuantity: Number(attr('data-line-quantity'))
      };
    }

    _request(key, quantity, line) {
      var self = this;
      // Snapshot BEFORE the request (#180): on a removal the row is gone from
      // the DOM and the line gone from the cart by the time the response lands.
      // Re-resolve the row by key first: a prior queued request's render may
      // have replaced the cart contents, detaching the node captured at click
      // time -- its data-line-* attributes freeze at the values from BEFORE
      // that request, so previousQuantity (and price/title) would be stale on
      // a rapid second edit of the same line. The fresh row carries the
      // server-rendered truth at the moment this request runs; fall back to
      // the captured node when the row no longer exists.
      var current = this.querySelector('[data-line-key="' + key + '"]') || line;
      var snapshot = this._lineSnapshot(key, quantity, current);
      return fetch(this.changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: this.sectionId + ',cart-drawer',
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.ok ? response.json() : Promise.reject(response);
        })
        .then(function (json) {
          if (json && json.sections && json.sections[self.sectionId]) {
            self._render(json);
            return;
          }
          // Preview/dev-theme sessions apply the mutation but omit bundled
          // sections from cart AJAX responses; re-fetch via the Section
          // Rendering GET (works everywhere). Inherit the page query string.
          var params = new URLSearchParams(window.location.search);
          params.set('sections', self.sectionId + ',cart-drawer');
          return fetch(window.location.pathname + '?' + params.toString())
            .then(function (response) {
              return response.ok ? response.json() : Promise.reject(response);
            })
            .then(function (sections) {
              json = json || {};
              json.sections = sections;
              self._render(json);
            });
        })
        .then(function () {
          // Swap replaces the line; if it's still connected the swap didn't
          // happen -- never leave the row stuck in its pending state.
          if (line && line.isConnected) line.removeAttribute('data-pending');
          // Success path ONLY (#180). The catch below reloads because the server
          // may already have applied the change, so a failed mutation must not
          // report a Klaviyo event. Guarded so a tracking fault can never fall
          // through into that reload.
          if (!snapshot) return;
          try {
            document.dispatchEvent(new CustomEvent('cart:line-changed', { detail: snapshot }));
          } catch (e) {
            // Tracking never breaks the bag.
          }
        })
        .catch(function () {
          if (line) line.removeAttribute('data-pending');
          // Never re-post the form from here: the server may have already
          // applied the change, and a native POST of the form's now-stale
          // updates[<line-key>] fields lands on Shopify's 422 "updates
          // parameter is invalid" error page. A reload renders the truth.
          window.location.reload();
        });
    }

    _render(json) {
      var sectionHtml = json && json.sections && json.sections[this.sectionId];
      if (sectionHtml) {
        var fresh = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('[data-cart-contents]');
        var live = this.querySelector('[data-cart-contents]');
        if (fresh && live) {
          live.replaceWith(fresh);
          this._announce(fresh);
          this._restoreFocus();
        }
      }
      // The <cart-drawer> controller swaps its own contents and syncs the
      // header count from this event (the payload still bundles 'cart-drawer').
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: json, sections: (json && json.sections) || null }
        })
      );
    }

    // Announce the mutation to screen readers via the persistent live region.
    _announce(fresh) {
      var region = this.querySelector('[data-cart-announce]');
      if (!region) return;
      var total = fresh.querySelector('.cart__row--total');
      var text = this.dataset.labelUpdated || '';
      if (total) text += '. ' + total.textContent.replace(/\s+/g, ' ').trim();
      region.textContent = text;
    }

    // Re-focus the control the user was on -- the swap otherwise drops focus to
    // <body>. Falls back to the page heading when the line was removed.
    _restoreFocus() {
      var hint = this._focusHint;
      this._focusHint = null;
      if (!hint) return;
      var active = document.activeElement;
      if (active && active !== document.body && !this.contains(active)) return;
      var target = null;
      if (hint.key && hint.hook) {
        var line = this.querySelector('[data-line-key="' + hint.key + '"]');
        if (line) target = line.querySelector('[' + hint.hook + ']');
      }
      if (!target) target = this.querySelector('.cart__heading') || this.querySelector('.cart__empty-title');
      if (!target) return;
      if (!/^(a|button|input|select|textarea)$/i.test(target.tagName) && !target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }
      target.focus();
    }

    _moveToWishlist(line) {
      if (!line) return;
      var productId = parseInt(line.getAttribute('data-product-id'), 10);
      var variantId = parseInt(line.getAttribute('data-variant-id'), 10);
      var rawUrl = line.getAttribute('data-product-url');
      if (
        window.__dcWishlistSavedVariantIds instanceof Set &&
        window.__dcWishlistSavedVariantIds.has(variantId)
      ) {
        this._toast(this.dataset.labelWishlistAlready);
        return;
      }
      var swat = window._swat;
      if (!swat || typeof swat.addToWishList !== 'function' || isNaN(variantId)) return;
      var du = rawUrl ? new URL(rawUrl, window.location.origin).href : rawUrl;
      var self = this;
      line.setAttribute('data-pending', '');
      swat.addToWishList(
        { empi: productId, epi: variantId, du: du },
        function () {
          document.dispatchEvent(
            new CustomEvent('wishlist:change', { detail: { productId: productId, variantId: variantId, added: true } })
          );
          self._toast(self.dataset.labelWishlistMoved, 'tick');
          self._change(line, 0);
        },
        function () {
          line.removeAttribute('data-pending');
          self._toast(self.dataset.labelWishlistFailed);
        }
      );
    }

    _toast(text, icon) {
      if (!text) return;
      document.dispatchEvent(new CustomEvent('toast:show', { detail: { text: text, icon: icon } }));
    }
  }

  if (!window.customElements.get('cart-items')) {
    window.customElements.define('cart-items', CartItems);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-description"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-description')) {
    class CollectionDescription extends HTMLElement {
      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;
        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-description-toggle]');
          if (!toggle) return;
          const body = this.querySelector('[data-description-body]');
          if (!body) return;
          const collapsed = body.classList.toggle('is-collapsed');
          toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          toggle.textContent = collapsed
            ? toggle.getAttribute('data-label-more')
            : toggle.getAttribute('data-label-less');
        });
      }

      disconnectedCallback() {
        this.__bound = false;
      }
    }

    customElements.define('collection-description', CollectionDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-header')) {
    class CollectionHeader extends HTMLElement {
      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;
        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-tagline-toggle]');
          if (!toggle) return;
          const tagline = toggle.closest('.collection-header__tagline');
          if (!tagline) return;
          const expanded = tagline.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          toggle.textContent = expanded
            ? toggle.getAttribute('data-label-less')
            : toggle.getAttribute('data-label-more');
        });
      }

      disconnectedCallback() {
        this.__bound = false;
      }
    }

    customElements.define('collection-header', CollectionHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterHelpCode extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.footer__help-code-button');
      this.output = this.querySelector('.footer__help-code-output');
      if (!this.button) return;

      this.ready = false;
      this.defaultLabel = this.button.textContent.trim();
      this.handleSDKReady = this.handleSDKReady.bind(this);
      this.button.addEventListener('click', () => this.requestCode());

      // The button stays disabled (set in markup) until the Noibu SDK is ready --
      // either it has already loaded, or it dispatches `noibuSDKReady` (deferred load).
      if (window.NOIBUJS) {
        this.setReady();
      } else {
        window.addEventListener('noibuSDKReady', this.handleSDKReady);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('noibuSDKReady', this.handleSDKReady);
    }

    handleSDKReady() {
      this.setReady();
    }

    setReady() {
      this.ready = true;
      this.button.disabled = false;
      window.removeEventListener('noibuSDKReady', this.handleSDKReady);
    }

    async requestCode() {
      if (!this.ready || !window.NOIBUJS || typeof window.NOIBUJS.requestHelpCode !== 'function') return;

      // Disable while the request is in flight (prevents double submits), then restore.
      this.button.disabled = true;
      this.button.textContent = this.dataset.loadingLabel || this.defaultLabel;

      try {
        const code = await window.NOIBUJS.requestHelpCode(false);
        if (code) this.output.textContent = code;
      } catch (error) {
        console.error('Noibu help code request failed', error);
      } finally {
        this.button.textContent = this.defaultLabel;
        this.button.disabled = false;
      }
    }
  }

  if (!customElements.get('footer-help-code')) {
    customElements.define('footer-help-code', FooterHelpCode);
  }

  /**
   * Records email marketing consent for a footer newsletter signup (#159),
   * gated like the Form section since #327 (honeypot + reCAPTCHA v3).
   *
   * The form itself is a plain GET to the hosted login screen and still ends
   * there: with JavaScript off, or with no endpoint configured, nothing here
   * runs and the navigation is unchanged. With JavaScript on, the submit is
   * held just long enough to mint a reCAPTCHA token (a few hundred ms once
   * Google's script is warm - the loader fires on first focus - with a 5 s
   * ceiling), the consent ping goes out with `keepalive`, and the form is then
   * submitted programmatically. `form.submit()` does not re-fire this listener,
   * so there is no loop.
   *
   * Fire-and-forget by design: the response is never read and never surfaced.
   * A failed or rejected ping loses nothing the old behaviour had, and the
   * profile form after login remains the consent backstop.
   */
  class FooterNewsletter extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form || !this.dataset.endpoint) return;
      this.recaptchaKey = this.dataset.recaptchaKey || '';
      this.designMode = this.dataset.designMode === 'true';
      this.honeypot = this.querySelector('input[name="hp_website"]');
      this.pending = false;

      // Load Google's script on first interaction, never in the editor.
      if (this.recaptchaKey && !this.designMode) {
        this.form.addEventListener(
          'focusin',
          () => {
            if (window.dcRecaptcha) window.dcRecaptcha.load(this.recaptchaKey);
          },
          { once: true }
        );
      }
      this.form.addEventListener('submit', (event) => this.ping(event));
    }

    ping(event) {
      // Let an invalid address fall through to the browser's own validation
      // instead of subscribing something the form is about to reject.
      if (event.defaultPrevented) return;
      const field = this.form.elements.login_hint;
      const email = field && field.value ? field.value.trim() : '';
      if (!email || (field.checkValidity && !field.checkValidity())) return;

      // Hold the navigation while the token is minted; a second Enter while
      // that is in flight must neither ping twice nor navigate early.
      event.preventDefault();
      if (this.pending) return;
      this.pending = true;

      const payload = { email: email, hp_website: this.honeypot ? this.honeypot.value : '' };
      const minted =
        this.recaptchaKey && !this.designMode && window.dcRecaptcha
          ? window.dcRecaptcha.token(this.recaptchaKey, 'newsletter_subscribe')
          : Promise.resolve('');
      const go = () => this.form.submit();

      minted.then((token) => {
        if (token) payload['g-recaptcha-response'] = token;
        // keepalive: the document is unloading a beat later, and without it the
        // browser is free to cancel the request mid-flight.
        fetch(this.dataset.endpoint, {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }).catch(() => {
          // Nothing to recover: the customer is on their way to the login
          // screen, and the profile form remains the backstop.
        });
        go();
      }, go);
    }
  }

  if (!customElements.get('footer-newsletter')) {
    customElements.define('footer-newsletter', FooterNewsletter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form"] && !Shopify.designMode) return;
  try {
    
  // reCAPTCHA v3 (#189). One loader per page, shared by every <dc-form>, injected
  // on the first interaction with any form so a page nobody submits from loads
  // nothing from Google.
  const RECAPTCHA_ACTION = 'form_submission';
  const RECAPTCHA_TIMEOUT_MS = 5000;
  const RECAPTCHA_POLL_MS = 100;

  function loadRecaptcha(key) {
    if (!key || window.grecaptcha || document.querySelector('script[data-dc-recaptcha]')) return;
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(key);
    script.async = true;
    script.defer = true;
    script.setAttribute('data-dc-recaptcha', '');
    document.head.appendChild(script);
  }

  // Resolves to a token, or '' when no key is set, Google has not loaded within
  // the timeout, or execute throws. The server decides what an empty token
  // means; the client never blocks the submit on a third-party script.
  function getRecaptchaToken(key) {
    if (!key) return Promise.resolve('');
    loadRecaptcha(key);
    return new Promise((resolve) => {
      let settled = false;
      const finish = (token) => {
        if (settled) return;
        settled = true;
        resolve(typeof token === 'string' ? token : '');
      };
      const timer = setTimeout(() => finish(''), RECAPTCHA_TIMEOUT_MS);
      const attempt = () => {
        if (settled) return;
        const api = window.grecaptcha;
        if (api && typeof api.ready === 'function' && typeof api.execute === 'function') {
          try {
            api.ready(() => {
              api.execute(key, { action: RECAPTCHA_ACTION }).then(
                (token) => {
                  clearTimeout(timer);
                  finish(token);
                },
                () => {
                  clearTimeout(timer);
                  finish('');
                }
              );
            });
          } catch (error) {
            clearTimeout(timer);
            finish('');
          }
          return;
        }
        setTimeout(attempt, RECAPTCHA_POLL_MS);
      };
      attempt();
    });
  }

  class DcForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.successEl = this.querySelector('[data-form-success]');
      this.dialog = this.querySelector('[data-form-dialog]');
      this.formError = this.querySelector('[data-form-error]');
      this.action = this.getAttribute('data-form-action') || '';
      this.designMode = this.getAttribute('data-design-mode') === 'true';
      this.recaptchaKey = this.getAttribute('data-recaptcha-key') || '';

      // Load Google's script on first interaction, never in the editor.
      if (this.recaptchaKey && !this.designMode) {
        this.form.addEventListener('focusin', () => loadRecaptcha(this.recaptchaKey), { once: true });
      }

      this.onSubmit = this.onSubmit.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.form.addEventListener('submit', this.onSubmit);
      this.form.addEventListener('input', this.onInput);
      this.form.addEventListener('click', this.onToggle);

      if (this.dialog) {
        const closeBtn = this.dialog.querySelector('[data-form-dialog-close]');
        if (closeBtn) closeBtn.addEventListener('click', () => this.dialog.close());
      }
    }

    disconnectedCallback() {
      if (this.form) {
        this.form.removeEventListener('submit', this.onSubmit);
        this.form.removeEventListener('input', this.onInput);
        this.form.removeEventListener('click', this.onToggle);
      }
    }

    controls() {
      return Array.from(this.form.querySelectorAll('[data-form-field-control]'));
    }

    errorSlot(control) {
      const wrap = control.closest('[data-form-field]');
      return wrap ? wrap.querySelector('[data-field-error]') : null;
    }

    messageFor(control) {
      if (control.validity.valueMissing && control.dataset.errorRequired) {
        return control.dataset.errorRequired;
      }
      if (control.validity.typeMismatch && control.dataset.errorEmail) {
        return control.dataset.errorEmail;
      }
      return control.validationMessage;
    }

    setError(control, message) {
      const slot = this.errorSlot(control);
      if (message) {
        control.setAttribute('aria-invalid', 'true');
        if (slot) slot.textContent = message;
      } else {
        control.removeAttribute('aria-invalid');
        if (slot) slot.textContent = '';
      }
    }

    onInput(event) {
      const control = event.target.closest('[data-form-field-control]');
      if (control && control.checkValidity()) this.setError(control, '');
    }

    // Expandable textarea: toggle the collapsed/expanded state on its circle-plus/minus button.
    onToggle(event) {
      const toggle = event.target.closest('[data-form-textarea-toggle]');
      if (!toggle) return;
      const wrap = toggle.closest('[data-form-textarea]');
      if (!wrap) return;
      const expanded = wrap.hasAttribute('data-expanded');
      if (expanded) {
        wrap.removeAttribute('data-expanded');
      } else {
        wrap.setAttribute('data-expanded', '');
      }
      toggle.setAttribute('aria-expanded', String(!expanded));
    }

    validate() {
      let firstInvalid = null;
      this.controls().forEach((control) => {
        if (control.checkValidity()) {
          this.setError(control, '');
        } else {
          this.setError(control, this.messageFor(control));
          if (!firstInvalid) firstInvalid = control;
        }
      });
      return firstInvalid;
    }

    reveal() {
      if (this.dialog) {
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
      } else if (this.successEl) {
        this.successEl.hidden = false;
        this.form.hidden = true;
        this.successEl.focus();
      }
    }

    showFormError(message) {
      if (this.formError) this.formError.textContent = message;
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.formError) this.formError.textContent = '';

      const firstInvalid = this.validate();
      if (firstInvalid) {
        firstInvalid.focus();
        return;
      }

      // Editor preview: reveal the success state without a network call.
      if (this.designMode) {
        this.reveal();
        return;
      }

      const generic = this.form.getAttribute('data-error-generic') || '';

      // Defensive: the action attribute is always set from a hardcoded proxy
      // path, but surface the failure rather than silently dropping the entry
      // if it is ever missing.
      if (!this.action) {
        console.warn('[dc-form] data-form-action is empty; submission not sent.');
        this.showFormError(generic);
        return;
      }

      const data = new FormData(this.form);
      const submitBtn = this.form.querySelector('[type="submit"]');
      const setPending = (pending) => {
        if (submitBtn) submitBtn.disabled = pending;
        if (pending) {
          this.setAttribute('aria-busy', 'true');
        } else {
          this.removeAttribute('aria-busy');
        }
      };

      // Disable the trigger while in flight so rapid double-clicks cannot
      // post twice; it stays disabled after success (the form is replaced or
      // overlaid, and a re-submit would duplicate the entry).
      setPending(true);
      getRecaptchaToken(this.recaptchaKey)
        .then((token) => {
          if (token) data.append('g-recaptcha-response', token);
          return fetch(this.action, { method: 'POST', body: data });
        })
        .then((response) => response.json())
        .then((result) => {
          if (result && result.status === 'success') {
            this.reveal();
            // Data layer (#270): enquiry_submit, keyed on the section title handle.
            this.dispatchEvent(new CustomEvent('form:submitted', {
              bubbles: true,
              detail: { handle: this.dataset.formHandle || '' },
            }));
          } else {
            setPending(false);
            this.showFormError(generic);
          }
        })
        .catch(() => {
          setPending(false);
          this.showFormError(generic);
        });
    }
  }

  if (!window.customElements.get('dc-form')) {
    window.customElements.define('dc-form', DcForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-balance"] && !Shopify.designMode) return;
  try {
    
  class GiftCardBalance extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-gcb-form]');
      if (!this.form) return;

      this.submitBtn = this.querySelector('[data-gcb-submit]');
      this.resultEl = this.querySelector('[data-gcb-result]');
      this.errorEl = this.querySelector('[data-gcb-error]');
      this.balanceEl = this.querySelector('[data-gcb-balance]');
      this.usedEl = this.querySelector('[data-gcb-used]');
      this.expiryEl = this.querySelector('[data-gcb-expiry]');
      this.numberInput = this.querySelector('[data-gcb-number]');
      this.pinInput = this.querySelector('[data-gcb-pin]');

      this.endpoint = '/apps/dotapparel21/api-checkGiftcardBalance';
      this.siteLocation = this.dataset.country || 'AU';
      this._busy = false;

      this._onSubmit = this._onSubmit.bind(this);
      this.form.addEventListener('submit', this._onSubmit);
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this._onSubmit);
    }

    // Toggle the loading state; the spinner + hidden label are pure CSS off aria-busy
    // (mirrors live, which shows a spinner in the button rather than any loading text).
    _setBusy(busy) {
      if (!this.submitBtn) return;
      this.submitBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    _hideStates() {
      if (this.resultEl) this.resultEl.hidden = true;
      if (this.errorEl) this.errorEl.hidden = true;
    }

    _showError() {
      this._hideStates();
      if (this.errorEl) this.errorEl.hidden = false;
    }

    // Mirrors the live headless formatMoney exactly: locale en-<siteLocation> (the visitor's
    // market via localization.country, the theme analogue of the headless per-store
    // siteLocation), currency hardcoded AUD (the balance page passes no currency, so live
    // falls back to its "AUD" default; the AP21 balance is a raw AUD figure, no FX),
    // narrowSymbol, and the trailing replace() that strips any residual currency text.
    // AU renders "$", NZ / US render "A$".
    _money(amount) {
      var n = Number(amount);
      if (!isFinite(n)) return '';
      var currency = 'AUD';
      try {
        return new Intl.NumberFormat('en-' + this.siteLocation, {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'narrowSymbol'
        }).format(n).replace(currency, '');
      } catch (e) {
        return String(amount);
      }
    }

    // Port of the live formatDate (normal branch): en-AU day/month/year with an
    // ordinal suffix on the day, e.g. "9th July 2026".
    _date(value) {
      if (!value) return '\u2014';
      var d = new Date(value);
      if (isNaN(d.getTime())) return '\u2014';
      var day = d.getDate();
      var mod = day % 10;
      var suffix;
      if (day > 3 && day < 21) suffix = 'th';
      else if (mod === 1) suffix = 'st';
      else if (mod === 2) suffix = 'nd';
      else if (mod === 3) suffix = 'rd';
      else suffix = 'th';
      var s = d.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
      return s.replace(/\b(\d{1,2})\b/, '$1' + suffix);
    }

    _showResult(data) {
      this._hideStates();
      if (this.balanceEl) this.balanceEl.textContent = this._money(data.availableAmount);
      if (this.usedEl) this.usedEl.textContent = this._money(data.usedAmount);
      if (this.expiryEl) this.expiryEl.textContent = this._date(data.expiryDate);
      if (this.resultEl) this.resultEl.hidden = false;
    }

    _onSubmit(event) {
      event.preventDefault();
      if (this._busy) return;

      // Trim in place before validating so a whitespace-only entry fails the
      // native `required` check (and shows the validation message) rather than
      // silently posting empty strings that fail the lookup with a generic error.
      if (this.numberInput) this.numberInput.value = this.numberInput.value.trim();
      if (this.pinInput) this.pinInput.value = this.pinInput.value.trim();

      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }

      this._hideStates();
      this._busy = true;
      this._setBusy(true);

      var self = this;
      var body = JSON.stringify({
        number: this.numberInput ? this.numberInput.value : '',
        pin: this.pinInput ? this.pinInput.value : ''
      });

      fetch(this.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      })
        .then(function (r) {
          return r.ok ? r.json() : Promise.reject(r);
        })
        .then(function (json) {
          self._busy = false;
          self._setBusy(false);
          if (json && json.status !== 'error' && json.data) {
            self._showResult(json.data);
          } else {
            self._showError();
          }
        })
        .catch(function () {
          self._busy = false;
          self._setBusy(false);
          self._showError();
        });
    }
  }

  if (!window.customElements.get('gift-card-balance')) {
    window.customElements.define('gift-card-balance', GiftCardBalance);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.update = this.update.bind(this);
      this.update();
      window.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
    }

    update() {
      const scrollY = window.scrollY || 0;
      this.setAttribute('data-at-top', scrollY <= 0 ? 'true' : 'false');

      const announcement = document.querySelector('[data-announcement]');
      const announcementHeight = announcement ? announcement.clientHeight : 0;
      const upper = scrollY >= announcementHeight ? 0 : announcementHeight - scrollY;
      const offset = this.offsetHeight + upper;
      document.documentElement.style.setProperty('--header-offset', offset + 'px');
    }
  }

  class HeaderDrawer extends HTMLElement {
    connectedCallback() {
      this.toggleButton = document.querySelector('[aria-controls="' + this.id + '"]');
      // The backdrop is a sibling, not a child, so it is found by id rather than
      // queried within this element.
      this.backdrop = document.querySelector('[data-drawer-backdrop="' + this.id + '"]');
      this.handleToggle = this.handleToggle.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleDetailsToggle = this.handleDetailsToggle.bind(this);
      this.handleBackdropClick = this.handleBackdropClick.bind(this);

      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', this.handleToggle);
      }
      if (this.backdrop) {
        this.backdrop.addEventListener('click', this.handleBackdropClick);
      }
      document.addEventListener('keydown', this.handleKeydown);
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.addEventListener('toggle', this.handleDetailsToggle, true);
    }

    disconnectedCallback() {
      if (this.toggleButton) {
        this.toggleButton.removeEventListener('click', this.handleToggle);
      }
      if (this.backdrop) {
        this.backdrop.removeEventListener('click', this.handleBackdropClick);
      }
      document.removeEventListener('keydown', this.handleKeydown);
      window.removeEventListener('resize', this.handleResize);
      this.removeEventListener('toggle', this.handleDetailsToggle, true);
    }

    get isOpen() {
      return this.hasAttribute('data-open');
    }

    // `viaKeyboard` is true when the open/close came from the keyboard (Enter/Space
    // on the toggle, Escape). Only then is focus moved onto a control that paints
    // the global :focus-visible ring. WebKit treats any script-moved focus as
    // focus-visible even after a touch tap, so focusing the first item on a
    // pointer open drew a 2px black bar under "NEW" on iOS (#255) -- the ring's
    // top and sides were clipped by the scrolling panel.
    open(viaKeyboard) {
      this.previouslyFocused = document.activeElement;
      this.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
      if (this.toggleButton) {
        this.toggleButton.setAttribute('aria-expanded', 'true');
        this.swapIcon(true);
      }
      // A11y: move focus into the dialog so SR users land inside it and Tab is trapped here.
      // Force a style flush first so the now-visible drawer can take focus (a still-hidden
      // element silently rejects focus). Keyboard opens land on the first item so Tab order
      // starts at the menu; pointer/touch opens park focus on the dialog container.
      void this.offsetHeight;
      const target = viaKeyboard ? this.getFocusable()[0] || this : this;
      target.focus();
    }

    close(viaKeyboard) {
      if (!this.isOpen) return;
      this.removeAttribute('data-open');
      document.body.style.overflow = '';
      this.querySelectorAll('details[data-mobile-nav-details]').forEach((details) => {
        details.open = false;
      });
      if (this.toggleButton) {
        this.toggleButton.setAttribute('aria-expanded', 'false');
        this.swapIcon(false);
      }
      if (viaKeyboard) {
        // A11y: return focus to the trigger (or the element focused before opening).
        const target = this.toggleButton && this.toggleButton.offsetParent !== null ? this.toggleButton : this.previouslyFocused;
        if (target && typeof target.focus === 'function') target.focus();
      } else if (this.contains(document.activeElement)) {
        // Pointer closes leave focus where the tap put it, as a native button click would;
        // just don't strand it inside the now-hidden dialog.
        document.activeElement.blur();
      }
    }

    getFocusable() {
      const selector = 'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
      return Array.from(this.querySelectorAll(selector)).filter((el) => el.offsetParent !== null && !el.closest('[hidden]'));
    }

    trapTab(event) {
      const focusables = this.getFocusable();
      if (focusables.length === 0) {
        event.preventDefault();
        this.focus();
        return;
      }
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;
      if (!this.contains(active) || active === this) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    }

    handleToggle(event) {
      // Enter/Space on a button dispatch a click with detail 0; pointer and touch clicks carry a count.
      const viaKeyboard = !event || event.detail === 0;
      if (this.isOpen) {
        this.close(viaKeyboard);
      } else {
        this.open(viaKeyboard);
      }
    }

    // Taps on the backdrop are pointer closes, so focus stays where the tap put it
    // rather than jumping back to the toggle.
    handleBackdropClick() {
      this.close(false);
    }

    swapIcon(open) {
      const iconOpen = this.toggleButton.querySelector('[data-icon-open]');
      const iconClose = this.toggleButton.querySelector('[data-icon-close]');
      if (iconOpen) iconOpen.toggleAttribute('hidden', open);
      if (iconClose) iconClose.toggleAttribute('hidden', !open);
    }

    handleKeydown(event) {
      if (!this.isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close(true);
      } else if (event.key === 'Tab') {
        this.trapTab(event);
      }
    }

    handleResize() {
      if (window.innerWidth >= 1072 && this.isOpen) {
        this.close(false);
      }
    }

    handleDetailsToggle(event) {
      const opened = event.target;
      if (!opened.open) return;
      const all = this.querySelectorAll('details[data-mobile-nav-details]');
      all.forEach(details => {
        if (details === opened) return;
        if (details.contains(opened) || opened.contains(details)) return;
        details.open = false;
      });
    }
  }

  if (!window.customElements.get('site-header')) {
    window.customElements.define('site-header', SiteHeader);
  }
  if (!window.customElements.get('header-drawer')) {
    window.customElements.define('header-drawer', HeaderDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function wireHeroStaticLinks(root) {
    var scope = root || document;
    var heroes = scope.querySelectorAll('.hero--split');
    heroes.forEach(function (hero) {
      var staticLink = hero.querySelector('[data-hero-static]');
      if (!staticLink) return;
      var slides = hero.querySelectorAll('[data-hero-link]');
      for (var i = 0; i < slides.length; i++) {
        var url = slides[i].getAttribute('data-hero-link');
        if (url) {
          staticLink.setAttribute('href', url);
          var label = slides[i].getAttribute('aria-label');
          if (label) {
            staticLink.setAttribute('aria-label', label);
            staticLink.setAttribute('title', label);
          }
          break;
        }
      }
    });
  }

  wireHeroStaticLinks(document);
  document.addEventListener('shopify:section:load', function (event) {
    wireHeroStaticLinks(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-grid"] && !Shopify.designMode) return;
  try {
    
  class ImageGrid extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('[data-ig-video]'));
      if (!this.videos.length) return;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduceMotion.matches) {
        this.videos.forEach((video) => {
          video.removeAttribute('autoplay');
          video.pause();
        });
        return;
      }

      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.play(entry.target);
            } else {
              entry.target.pause();
            }
          });
        },
        { rootMargin: '200px' }
      );

      this.videos.forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    play(video) {
      if (video.offsetParent === null) return;
      const playback = video.play();
      if (playback && playback.catch) playback.catch(() => {});
    }
  }

  if (!window.customElements.get('image-grid')) {
    window.customElements.define('image-grid', ImageGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-links"] && !Shopify.designMode) return;
  try {
    
  class ImageLinks extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('[data-il-video]'));
      if (!this.videos.length) return;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduceMotion.matches) {
        this.videos.forEach((video) => {
          video.removeAttribute('autoplay');
          video.pause();
        });
        return;
      }

      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.play(entry.target);
            } else {
              entry.target.pause();
            }
          });
        },
        { rootMargin: '200px' }
      );

      this.videos.forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    play(video) {
      if (video.offsetParent === null) return;
      const playback = video.play();
      if (playback && playback.catch) playback.catch(() => {});
    }
  }

  if (!window.customElements.get('image-links')) {
    window.customElements.define('image-links', ImageLinks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-grid"] && !Shopify.designMode) return;
  try {
    
  class ImageTextGrid extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('[data-itg-video]'));
      if (!this.videos.length) return;

      // Respect reduced-motion: strip the native autoplay and pause, leaving the poster.
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduceMotion.matches) {
        this.videos.forEach((video) => {
          video.removeAttribute('autoplay');
          video.pause();
        });
        return;
      }

      // Native `autoplay muted` starts the in-view video and the browser switches it
      // across the desktop/mobile breakpoint. This observer only pauses videos that
      // scroll out of view (and resumes them) for browsers that don't do it natively.
      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.play(entry.target);
            } else {
              entry.target.pause();
            }
          });
        },
        { rootMargin: '200px' }
      );

      this.videos.forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    play(video) {
      if (video.offsetParent === null) return;
      const playback = video.play();
      if (playback && playback.catch) playback.catch(() => {});
    }
  }

  if (!window.customElements.get('image-text-grid')) {
    window.customElements.define('image-text-grid', ImageTextGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dc-instagram')) {
    customElements.define(
      'dc-instagram',
      class extends HTMLElement {
        connectedCallback() {
          const target = this.querySelector('[data-instagram-target]');
          // Guard double-injection on theme-editor re-render / Section Rendering API.
          if (!target || target.children.length > 0) return;

          // The Dash Hudson embeds call these globals; stub them so they never throw.
          if (typeof window.goPrevious === 'undefined') window.goPrevious = function () { return null; };
          if (typeof window.goNext === 'undefined') window.goNext = function () { return null; };
          if (typeof window.closeDialogue === 'undefined') window.closeDialogue = function () { return null; };

          const grid = this.dataset.mode === 'grid';
          const src = grid
            ? '//cdn.dashhudson.com/web/js/embed.js'
            : '//cdn.dashhudson.com/web/js/board-carousel-embed.js';
          const params = grid
            ? {
                name: 'likeshop',
                id: '5424',
                idType: 'brand_id',
                rowSize: '3',
                gapSize: '2',
                mobileRowSize: '2',
                mobileGapSize: '4',
                callToAction: 'shop_now',
                hidePopupFooter: 'true',
                highRes: '0',
                lazy: 'true',
                showHeader: '0',
                // #247: hasHitRowLimit() disarms the widget's scroll-driven paging at
                // rowLimit x rowSize tiles (50 x 3 = 150, three 50-tile pages). Keep in
                // step with maxTiles/pageSize in initLoadMore below.
                rowLimit: '50',
              }
            : {
                name: 'dhboard-carousel',
                galleryId: this.dataset.feed,
                rowSize: '4',
                gapSize: '1',
                mobileRowSize: '2',
                mobileGapSize: '1',
                lazy: 'true',
                callToAction: 'shop_now',
              };

          const script = document.createElement('script');
          script.src = src;
          script.async = true;
          Object.keys(params).forEach(function (key) {
            script.dataset[key] = params[key];
          });
          target.appendChild(script);

          if (grid) this.initLoadMore(target);
        }

        // #247: the widget offers row-limit capping but no load-more UI, so the
        // reveal is ours. Tiles past the cap stay in the DOM (the featured-tile
        // nth-child pattern needs stable indices) but are display:none'd; the
        // widget keeps prefetching hidden pages as the viewport nears the feed
        // bottom, so a click usually reveals instantly.
        initLoadMore(target) {
          const wrap = this.querySelector('[data-instagram-more]');
          const trigger = this.querySelector('[data-instagram-more-trigger]');
          if (!wrap || !trigger) return;

          const pageSize = 50; // the widget's default page_size
          const maxTiles = 150; // rowLimit 50 x rowSize 3, set in params above
          let revealed = pageSize;
          let exhausted = false;

          const apply = () => {
            const tiles = target.querySelectorAll('.ls-photo-wrapper');
            tiles.forEach((tile, index) => {
              tile.classList.toggle('instagram__tile--capped', index >= revealed);
            });
            // Show while hidden tiles exist, or while a full final page suggests the
            // feed may have more to give (a short page means it's spent).
            const canReveal = tiles.length > revealed;
            const mayLoadMore =
              !exhausted &&
              tiles.length > 0 &&
              tiles.length < maxTiles &&
              tiles.length % pageSize === 0;
            wrap.hidden = !canReveal && !mayLoadMore;
          };

          trigger.addEventListener('click', () => {
            const before = target.querySelectorAll('.ls-photo-wrapper').length;
            revealed = Math.min(revealed + pageSize, maxTiles);
            apply();
            // The widget's loader only runs on window scroll events; nudge it in
            // case the next page wasn't prefetched yet.
            window.dispatchEvent(new Event('scroll'));
            window.setTimeout(() => {
              const after = target.querySelectorAll('.ls-photo-wrapper').length;
              if (after === before && after <= revealed) exhausted = true;
              apply();
            }, 3000);
          });

          new MutationObserver(apply).observe(target, { childList: true, subtree: true });
          apply();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /*
    Sticky-bottom buy box -- ports the live headless PDP's pinning behaviour.

    The media column keeps a fixed sticky top (CSS). The buy box's sticky top is
    min(header-offset, viewportHeight - columnHeight): a column shorter than the
    viewport pins under the header exactly as the CSS already does, while a
    column TALLER than the viewport takes a negative top, so it scrolls fully
    into view first and only then pins by its bottom edge -- nothing is left
    clipped below the fold.

    Only the negative branch is written as an inline top. When the header offset
    wins, min() resolves to the same value the CSS rule already produces, so the
    inline top is cleared instead and `top: var(--header-offset, 60px)` keeps
    following the header's scroll-driven offset changes rather than freezing a
    stale number. Identical geometry, one less thing to keep in sync.
  */
  class StickyBuyBox extends HTMLElement {
    connectedCallback() {
      // Matches the min-width: 67rem breakpoint that turns on position: sticky.
      this.mq = window.matchMedia('(min-width: 67rem)');
      this.update = this.update.bind(this);

      this.update();
      this.mq.addEventListener('change', this.update);
      window.addEventListener('resize', this.update, { passive: true });

      // Height changes the resize event cannot see: the details accordion
      // opening/closing, variant-driven content swaps, blocks hydrating late.
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.mq) this.mq.removeEventListener('change', this.update);
      window.removeEventListener('resize', this.update);
      if (this.observer) this.observer.disconnect();
    }

    // Resolved --header-offset (the header writes it in px on the root element),
    // falling back to the same 60px default the CSS declaration uses.
    get headerOffset() {
      const offset = parseFloat(getComputedStyle(this).getPropertyValue('--header-offset'));
      return Number.isNaN(offset) ? 60 : offset;
    }

    update() {
      // Not sticky (setting off, or below the breakpoint): an inline top would be
      // inert, but clear it anyway so nothing lingers when the breakpoint flips.
      if (!this.classList.contains('main-product__buy-box--sticky') || !this.mq.matches) {
        this.style.top = '';
        return;
      }

      // Writing top never changes this element's height, so the observer that
      // triggered this cannot re-trigger itself.
      const available = window.innerHeight - this.getBoundingClientRect().height;
      this.style.top = available < this.headerOffset ? available + 'px' : '';
    }
  }

  if (!customElements.get('sticky-buy-box')) {
    customElements.define('sticky-buy-box', StickyBuyBox);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-store"] && !Shopify.designMode) return;
  try {
    
  class MainStore extends HTMLElement {
    connectedCallback() {
      var url = new URLSearchParams(window.location.search);
      var from = this._safeFrom(url.get('from'));
      var back = this.querySelector('[data-main-store-back]');
      if (!from) return;
      if (back) back.setAttribute('href', from);

      var pos = null;
      try {
        var fromUrl = new URL(from, window.location.origin);
        var raw = fromUrl.searchParams.get('position');
        if (raw) {
          var parts = raw.split(',');
          var lat = parseFloat(parts[0]);
          var lng = parseFloat(parts[1]);
          if (!isNaN(lat) && !isNaN(lng)) pos = { lat: lat, lng: lng };
        }
      } catch (e) {
        pos = null;
      }
      if (!pos) return;

      var slat = parseFloat(this.dataset.lat);
      var slng = parseFloat(this.dataset.lng);
      if (isNaN(slat) || isNaN(slng)) return;

      var d = this._distanceKm(pos, { lat: slat, lng: slng });
      var distEl = this.querySelector('[data-main-store-distance]');
      if (distEl) {
        distEl.textContent = (this.dataset.distanceTemplate || '__D__').replace('__D__', d.toFixed(2) + 'kms');
        distEl.hidden = false;
      }
    }

    // Only accept ?from as a SAME-ORIGIN path. Rejects javascript: URIs, external
    // URLs and protocol-relative (//host) values so the back link can't become a DOM
    // XSS / open-redirect vector. Returns a relative path (or null to fall back).
    _safeFrom(raw) {
      if (!raw) return null;
      try {
        var u = new URL(raw, window.location.origin);
        if (u.origin !== window.location.origin) return null;
        return u.pathname + u.search + u.hash;
      } catch (e) {
        return null;
      }
    }

    _distanceKm(a, b) {
      var R = 6371;
      var dLat = this._deg2rad(b.lat - a.lat);
      var dLng = this._deg2rad(b.lng - a.lng);
      var x =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this._deg2rad(a.lat)) * Math.cos(this._deg2rad(b.lat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
    }

    _deg2rad(deg) {
      return deg * (Math.PI / 180);
    }
  }

  if (!window.customElements.get('main-store')) {
    window.customElements.define('main-store', MainStore);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-subnav"] && !Shopify.designMode) return;
  try {
    
  class PageSubnavSwitcher extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-switcher-toggle]');
      this.bar = this.closest('.page-subnav__bar');
      this.iconOpen = this.querySelector('[data-icon-open]');
      this.iconClose = this.querySelector('[data-icon-close]');
      if (!this.toggle) return;

      this.onToggle = this.onToggle.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.toggle.addEventListener('click', this.onToggle);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    get isOpen() {
      return this.toggle.getAttribute('aria-expanded') === 'true';
    }

    setOpen(open) {
      this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.classList.toggle('is-open', open);
      if (this.bar) this.bar.classList.toggle('is-open', open);
      if (this.iconOpen) this.iconOpen.hidden = open;
      if (this.iconClose) this.iconClose.hidden = !open;
    }

    onToggle() {
      this.setOpen(!this.isOpen);
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.setOpen(false);
        this.toggle.focus();
      }
    }

    onDocumentClick(event) {
      if (this.isOpen && !this.contains(event.target)) this.setOpen(false);
    }
  }

  if (!customElements.get('page-subnav-switcher')) {
    customElements.define('page-subnav-switcher', PageSubnavSwitcher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  class PasswordReveal extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-reveal-toggle]');
      this.panel = this.querySelector('[data-reveal-panel]');
      this.input = this.querySelector('input[type="password"]');

      if (!this.toggle || !this.panel) return;

      const hasError = this.querySelector('[data-reveal-error]') !== null;

      this.toggle.hidden = false;
      this.toggle.addEventListener('click', () => this.open());

      if (hasError) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.panel.hidden = false;
      this.toggle.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'true');
      if (this.input) this.input.focus();
    }

    close() {
      this.panel.hidden = true;
      this.toggle.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('password-reveal')) {
    customElements.define('password-reveal', PasswordReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy"] && !Shopify.designMode) return;
  try {
    
  class PolicyToc extends HTMLElement {
    connectedCallback() {
      this.buildNav();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    buildNav() {
      const nav = this.querySelector('[data-policy-toc-nav]');
      const list = this.querySelector('[data-policy-toc-list]');
      if (!nav || !list) return;

      const sections = this.querySelectorAll('.policy-section[data-toc-title]');
      const fragment = document.createDocumentFragment();

      sections.forEach((section) => {
        const title = section.getAttribute('data-toc-title');
        if (!title || !section.id) return;
        const item = document.createElement('li');
        item.className = 'policy__toc-item';
        const link = document.createElement('a');
        link.className = 'policy__toc-link';
        link.href = '#' + section.id;
        link.textContent = title;
        item.appendChild(link);
        fragment.appendChild(item);
      });

      if (fragment.childNodes.length === 0) return;
      list.appendChild(fragment);
      nav.hidden = false;
    }

    handleClick(event) {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', link.getAttribute('href'));
    }
  }

  if (!customElements.get('policy-toc')) {
    customElements.define('policy-toc', PolicyToc);
  }

  class PolicySwitcher extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-switcher-toggle]');
      this.bar = this.closest('.policy__bar');
      this.iconOpen = this.querySelector('[data-icon-open]');
      this.iconClose = this.querySelector('[data-icon-close]');
      if (!this.toggle) return;

      this.onToggle = this.onToggle.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.toggle.addEventListener('click', this.onToggle);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    get isOpen() {
      return this.toggle.getAttribute('aria-expanded') === 'true';
    }

    setOpen(open) {
      this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.classList.toggle('is-open', open);
      if (this.bar) this.bar.classList.toggle('is-open', open);
      if (this.iconOpen) this.iconOpen.hidden = open;
      if (this.iconClose) this.iconClose.hidden = !open;
    }

    onToggle() {
      this.setOpen(!this.isOpen);
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.setOpen(false);
        this.toggle.focus();
      }
    }

    onDocumentClick(event) {
      if (this.isOpen && !this.contains(event.target)) this.setOpen(false);
    }
  }

  if (!customElements.get('policy-switcher')) {
    customElements.define('policy-switcher', PolicySwitcher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shared-wishlist"] && !Shopify.designMode) return;
  try {
    
  class DcSharedWishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.loadingEl = this.querySelector('[data-wishlist-loading]');
      this.emptyEl = this.querySelector('[data-wishlist-empty]');
      this.cardSection = this.dataset.cardSection || 'wishlist-card';
      this.swymEnabled = this.dataset.swymEnabled === 'true';
      this.concurrency = 6;
      this.rendered = false;
      this.loading = false;
      // #274: live pages the shared list at 8 too (same WishlistLayout).
      this.pageSize = 8;
      this.page = 1;
      this.gridVisible = false;
      this.paginationEl = this.querySelector('[data-wishlist-pagination]');
      this.paginator = this.paginationEl ? this.paginationEl.querySelector('dc-pagination') : null;
      this.onPageChange = this.handlePageChange.bind(this);
      if (this.paginator) this.paginator.addEventListener('pagination:change', this.onPageChange);

      this.onReady = this.handleReady.bind(this);
      this.start();
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:ready', this.onReady);
      if (this.paginator) this.paginator.removeEventListener('pagination:change', this.onPageChange);
      if (this.fallbackTimer) clearTimeout(this.fallbackTimer);
      if (this.credsTimer) clearTimeout(this.credsTimer);
    }

    start() {
      if (!this.swymEnabled) {
        this.showEmpty();
        return;
      }
      // Swym's own shared-page contract reads `hkey` OR `lid`
      // (`swat.ui.renderSharedWishlistInContainer`: `queryParams["hkey"] ||
      // queryParams["lid"]`). Our own share modal always emits both with the
      // same value, but links Swym itself mints (the emailList message, social
      // shares) can carry `hkey` alone - read either so those still resolve.
      const params = new URLSearchParams(window.location.search);
      this.lid = params.get('lid') || params.get('hkey') || '';
      if (!this.lid) {
        this.showEmpty();
        this.toast(this.dataset.labelInvalidLink);
        return;
      }
      // The coordinator supplies the Swym creds (host/pid/regid/sessionid);
      // the shared list itself is fetched here, not from wishlist:items - the
      // coordinator read is the VISITOR's list, this page shows someone else's.
      if (window.__dcWishlistReady) {
        this.load();
        return;
      }
      document.addEventListener('wishlist:ready', this.onReady, { once: true });
      this.fallbackTimer = setTimeout(() => {
        if (!this.rendered && !this.loading) this.showEmpty();
      }, 10000);
    }

    handleReady() {
      this.load();
    }

    load() {
      if (this.loading || this.rendered) return;
      this.loading = true;
      if (this.fallbackTimer) {
        clearTimeout(this.fallbackTimer);
        this.fallbackTimer = null;
      }
      const creds = this.resolveCreds();
      if (!creds) {
        this.waitForCreds();
        return;
      }
      const url = creds.host + '/api/v3/lists/fetch-list-with-contents?pid=' + encodeURIComponent(creds.pid);
      const body = new URLSearchParams();
      body.set('regid', creds.regid);
      body.set('sessionid', creds.sessionid);
      body.set('lid', this.lid);
      const self = this;
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: body.toString(),
      })
        // Live parity: `swym.store-api.ts#fetchListWithContents` does
        // `return await response.json()` with NO `res.ok` check, so a Swym
        // refusal - 401 `sw-unauth-acl` when the list was never marked public,
        // 404 `sw-entity-notfound` for a list this store doesn't know - parses
        // into an error object with no `items`, and live falls straight through
        // to the plain empty state. Its own try/catch swallows network failures
        // into `{ lid: '', items: [] }` too, so live's "Unable to load shared
        // wishlist" toast never fires for a failed list read. Read the body
        // whatever the status and keep the toast for a genuinely thrown fetch
        // (both were firing it before - the #86 report).
        .then((res) => res.text())
        .then((text) => {
          let data = null;
          try {
            data = JSON.parse(text);
          } catch (e) {
            data = null;
          }
          if (data && data.error) {
            console.warn('shared-wishlist: Swym refused the list', data.type || data.msg || '');
          }
          const entries = data && Array.isArray(data.items) ? data.items : [];
          const items = entries
            .map((entry) => self.normalise(entry))
            .filter((item) => item && item.handle && !Number.isNaN(item.variantId));
          self.renderItems(items);
        })
        .catch(() => {
          self.showEmpty();
          self.toast(self.dataset.labelLoadFailed);
        });
    }

    // Swym rejects the read outright without a registered shopper (400
    // `sw-badregid` / schema error), so the recipient needs their own Swym
    // identity even to read someone else's public list. Prefer the coordinator's
    // published creds; fall back to the same discovery it uses, because the
    // coordinator degrades to `null` when its 8s budget expires before the app
    // embed has booted - a cold first visit (CDN fetch of swym-shopify.js, then
    // the regid registration round-trip) is exactly what a share-link recipient
    // does. Live never gives up there either: `shared-wishlist.tsx` mints a
    // regid on demand before fetching.
    resolveCreds() {
      const published = window.__dcWishlistCreds;
      if (this.credsUsable(published)) return published;
      const session = window._swat && window._swat.session;
      const sw = session && session.sw;
      const late = {
        host: sw && sw.swymHost,
        pid: (sw && sw.pid) || this.cookie('swym-pid'),
        regid: this.cookie('swym-swymRegid'),
        sessionid: session && session.sessionId,
      };
      return this.credsUsable(late) ? late : null;
    }

    credsUsable(creds) {
      return !!(creds && creds.host && creds.pid && creds.regid && creds.sessionid);
    }

    cookie(name) {
      const parts = document.cookie ? document.cookie.split(';') : [];
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i].trim();
        if (part.indexOf(name + '=') === 0) {
          return decodeURIComponent(part.slice(name.length + 1));
        }
      }
      return '';
    }

    // Bounded watch for credentials the SDK is still in the middle of producing
    // (10s past the coordinator's own degrade), then the standard empty state.
    // The loading skeleton stays up meanwhile, so a slow Swym boot reads as
    // "still loading" rather than "this wishlist is empty".
    waitForCreds() {
      const self = this;
      this.loading = false;
      this.credsTries = (this.credsTries || 0) + 1;
      if (this.credsTries > 40) {
        console.warn('shared-wishlist: Swym credentials unavailable');
        this.showEmpty();
        return;
      }
      this.credsTimer = setTimeout(() => self.load(), 250);
    }

    normalise(entry) {
      if (!entry) return null;
      const url = entry.du || '';
      return {
        variantId: parseInt(entry.epi, 10),
        handle: this.handleFromUrl(url),
        title: entry.dt || '',
      };
    }

    handleFromUrl(url) {
      if (!url) return '';
      const marker = '/products/';
      const at = url.indexOf(marker);
      if (at === -1) return '';
      const rest = url.slice(at + marker.length);
      return rest.split('?')[0].split('#')[0].split('/')[0];
    }

    renderItems(items) {
      if (this.rendered) return;
      this.rendered = true;
      if (!items.length) {
        this.showEmpty();
        return;
      }
      items.sort((a, b) => String(a.title).localeCompare(String(b.title)));

      const slots = items.map((item) => {
        const li = document.createElement('li');
        li.className = 'shared-wishlist__item';
        this.grid.appendChild(li);
        return { item: item, slot: li };
      });

      // #274: visible page first, remaining pages hydrate hidden behind it.
      this.applyPage();
      const firstPage = slots.slice(0, this.pageSize);
      const rest = slots.slice(this.pageSize);
      this.hydrate(firstPage)
        .then(() => {
          if (this.grid.children.length > 0) this.showGrid();
          else this.showEmpty();
          return this.hydrate(rest);
        })
        .then(() => {
          if (this.rendered && this.grid.children.length === 0) this.showEmpty();
        });
    }

    hydrate(slots) {
      let index = 0;
      const self = this;
      const worker = () => {
        if (index >= slots.length) return Promise.resolve();
        const current = slots[index++];
        return self.fetchCard(current.item, current.slot).then(worker);
      };
      const runners = [];
      const count = Math.min(this.concurrency, slots.length);
      for (let i = 0; i < count; i++) runners.push(worker());
      return Promise.all(runners);
    }

    // The saved variant seeds the card's pre-selected quick-shop size. Unlike
    // the wishlist page there is no saved-state force-mark: the hearts here are
    // live elements that seed from the coordinator and reflect the VISITOR's
    // own list, not the shared one.
    fetchCard(item, slot) {
      let url = '/products/' + encodeURIComponent(item.handle) + '?section_id=' + encodeURIComponent(this.cardSection);
      if (item.variantId) url += '&variant=' + encodeURIComponent(item.variantId);
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then((res) => (res.ok ? res.text() : ''))
        .then((html) => {
          const markup = html ? html.trim() : '';
          if (!markup) {
            this.removeSlot(slot);
            return;
          }
          slot.innerHTML = markup;
        })
        .catch(() => this.removeSlot(slot));
    }

    toast(text) {
      if (!text) return;
      document.dispatchEvent(new CustomEvent('toast:show', { detail: { text: text } }));
    }

    // #274: same paging contract as the wishlist page (see applyPage there);
    // this page has no remove path, so reflow only follows failed card fetches.
    applyPage() {
      if (!this.grid) return;
      const slots = Array.prototype.slice.call(this.grid.children);
      const total = Math.ceil(slots.length / this.pageSize);
      if (this.page > total) this.page = Math.max(1, total);
      if (this.page < 1) this.page = 1;
      const start = (this.page - 1) * this.pageSize;
      const end = start + this.pageSize;
      slots.forEach((slot, i) => {
        slot.hidden = i < start || i >= end;
      });
      if (this.paginator) {
        this.paginator.setAttribute('total-pages', String(total));
        this.paginator.setAttribute('current-page', String(this.page));
      }
      if (this.paginationEl) this.paginationEl.hidden = !this.gridVisible || total <= 1;
    }

    handlePageChange(e) {
      const page = e && e.detail ? parseInt(e.detail.page, 10) : NaN;
      if (Number.isNaN(page) || page === this.page) return;
      this.page = page;
      this.applyPage();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    showGrid() {
      if (this.loadingEl) this.loadingEl.hidden = true;
      if (this.emptyEl) this.emptyEl.hidden = true;
      if (this.grid) this.grid.hidden = false;
      this.gridVisible = true;
      this.applyPage();
    }

    showEmpty() {
      if (this.loadingEl) this.loadingEl.hidden = true;
      if (this.grid) this.grid.hidden = true;
      if (this.emptyEl) this.emptyEl.hidden = false;
      this.gridVisible = false;
      if (this.paginationEl) this.paginationEl.hidden = true;
    }

    removeSlot(slot) {
      if (slot && slot.parentNode) slot.parentNode.removeChild(slot);
      this.applyPage();
    }
  }

  if (!window.customElements.get('dc-shared-wishlist-page')) {
    window.customElements.define('dc-shared-wishlist-page', DcSharedWishlistPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide-page"]) return;
  try {
    
  class SizeGuidePage extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      // Mobile stack: the CSS force-open block below 40rem is the no-JS
      // fallback; with JS we make the state real -- every guide open=true and
      // its summary out of the tab order (an inert heading, not a control).
      // The shared accordion `name` must come off first: exclusivity would
      // otherwise leave only the last guide open.
      this.mobileQuery = window.matchMedia('(max-width: 39.9375rem)');
      this.syncMobileState = this.syncMobileState.bind(this);
      this.mobileQuery.addEventListener('change', this.syncMobileState);
      this.syncMobileState();
      this.openFromQuery();
    }

    disconnectedCallback() {
      this.mobileQuery.removeEventListener('change', this.syncMobileState);
    }

    syncMobileState() {
      const mobile = this.mobileQuery.matches;
      this.querySelectorAll('details[data-tags]').forEach((details) => {
        const summary = details.querySelector('summary');
        if (mobile) {
          details.removeAttribute('name');
          details.open = true;
          if (summary) summary.tabIndex = -1;
        } else {
          details.open = false;
          details.setAttribute('name', 'size-guide-accordion');
          if (summary) summary.tabIndex = 0;
        }
      });
    }

    onClick(event) {
      const link = event.target.closest('a[href^="#sgp-"]');
      if (!link) return;
      const target = this.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      this.openGuide(target);
    }

    openGuide(details) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const wasOpen = details.open;
      details.open = true;
      // Move focus with the disclosure (jump link / deep link) so keyboard and
      // AT users land on the guide they opened; skip inert mobile summaries.
      const summary = details.querySelector('summary');
      if (summary && summary.tabIndex !== -1) summary.focus({ preventScroll: true });
      const scroll = () => details.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (wasOpen || reduceMotion) {
        scroll();
        return;
      }
      // The panel expands via a 0.25s block-size transition. A smooth
      // scrollIntoView fired synchronously computes its target against the
      // not-yet-expanded (shorter) document and clamps short of the 100px
      // scroll-margin offset for guides near the page foot -- let the
      // expansion finish before scrolling.
      setTimeout(scroll, 300);
    }

    openFromQuery() {
      const raw = new URLSearchParams(window.location.search).get('tags');
      if (!raw) return;
      const urlTags = raw.split(',').map((tag) => tag.trim()).filter(Boolean);
      if (!urlTags.length) return;

      const match = [...this.querySelectorAll('details[data-tags]')].find((details) => {
        const tags = details.getAttribute('data-tags').split(',').map((tag) => tag.trim()).filter(Boolean);
        return tags.length > 0 && tags.every((tag) => urlTags.includes(tag));
      });
      if (!match) return;

      setTimeout(() => this.openGuide(match), 250);
    }
  }

  if (!customElements.get('size-guide-page')) {
    customElements.define('size-guide-page', SizeGuidePage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  class StoreLocator extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      this.country = this.dataset.country || 'au';
      this.apiKey = this.dataset.apiKey || '';
      this.mapId = this.dataset.mapId || '';
      this.distanceTpl = this.dataset.distanceTemplate || '__D__kms';

      this.headEl = this.querySelector('[data-store-locator-head]');
      this.input = this.querySelector('[data-store-search]');
      this.predictionsEl = this.querySelector('[data-store-predictions]');
      this.spinnerEl = this.querySelector('[data-store-spinner]');
      this.geoBtn = this.querySelector('[data-store-geo]');
      this.submitBtn = this.querySelector('[data-store-submit]');
      this.filterEl = this.querySelector('[data-store-locator-filter]');
      this.filterToggle = this.querySelector('[data-store-filter-toggle]');
      this.filterOptions = this.querySelector('[data-store-filter-options]');
      this.mapArea = this.querySelector('[data-store-locator-map]');
      this.mapToggle = this.querySelector('[data-store-map-toggle]');
      this.listEl = this.querySelector('[data-store-locator-list]');
      this.emptyEl = this.querySelector('[data-store-locator-empty]');

      this._predictions = [];
      this._activeIndex = -1;
      this._debounce = null;

      this._wireSearch();
      this._wireFilter();
      this._wireMapToggle();

      var url = new URLSearchParams(window.location.search);
      this._filter = url.get('filter') || '';
      this._position = this._parsePosition(url.get('position'));

      if (this.filterOptions) {
        try {
          var checked = this.filterOptions.querySelector('input[value="' + this._cssEscape(this._filter) + '"]');
          if (checked) checked.checked = true;
        } catch (e) {
          /* a malformed ?filter can produce an invalid selector; ignore it */
        }
      }

      if (this._position) {
        this._enterMapState();
      } else {
        this.dataset.state = 'form';
      }
    }

    disconnectedCallback() {
      if (this._onDocPointerDown) {
        document.removeEventListener('pointerdown', this._onDocPointerDown);
      }
    }

    _wireSearch() {
      var self = this;
      if (this.input) {
        this.input.addEventListener('input', function () {
          clearTimeout(self._debounce);
          var q = self.input.value.trim();
          if (q.length < 3) {
            self._hidePredictions();
            return;
          }
          self._debounce = setTimeout(function () {
            self._fetchPredictions(q);
          }, 1000);
        });
        this.input.addEventListener('keydown', function (e) {
          self._onInputKey(e);
        });
      }
      if (this.geoBtn) {
        this.geoBtn.addEventListener('click', function () {
          self._geolocate();
        });
      }
      if (this.submitBtn) {
        // Live's search button has no onClick; when the predictions dropdown
        // is open, commit the active (or first) prediction, else no-op.
        this.submitBtn.addEventListener('click', function () {
          if (self.predictionsEl && !self.predictionsEl.hidden && self._predictions.length) {
            var idx = self._activeIndex >= 0 ? self._activeIndex : 0;
            self._select(self._predictions[idx]);
          }
        });
      }
      this._onDocPointerDown = function (e) {
        if (self.predictionsEl && !self.predictionsEl.hidden && !e.target.closest('.store-locator__field')) {
          self._hidePredictions();
        }
      };
      document.addEventListener('pointerdown', this._onDocPointerDown);
    }

    _wireFilter() {
      var self = this;
      if (this.filterToggle) {
        this.filterToggle.addEventListener('click', function () {
          var open = self.filterToggle.getAttribute('aria-expanded') === 'true';
          self.filterToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      }
      if (this.filterOptions) {
        this.filterOptions.addEventListener('change', function (e) {
          if (e.target && e.target.name === 'store-brand') self._setFilter(e.target.value);
        });
      }
    }

    _wireMapToggle() {
      var self = this;
      if (!this.mapToggle) return;
      this.mapToggle.addEventListener('click', function () {
        // One-way (live parity): open the map; the overlay + button disappear and stay gone.
        self.dataset.mapOpen = 'true';
      });
    }

    _enterMapState() {
      this.dataset.state = 'map';
      // Baseline: sort + number the full in-market list right away. This works even
      // before the map/loader bundle runs (it needs only the position + card coords),
      // so the list is never shown unsorted. The map refines it to the viewport on bounds.
      this._render(this._allHandles());
      if (this.apiKey) this._createMap();
    }

    _createMap() {
      var map = document.createElement('store-map');
      map.className = 'store-locator__map-el';
      map.setAttribute('data-mode', 'directory');
      map.setAttribute('data-api-key', this.apiKey);
      map.setAttribute('data-map-id', this.mapId);
      map.setAttribute('data-stores-id', 'store-locator-stores');
      map.setAttribute('data-position', this._position.lat + ',' + this._position.lng);
      this.mapArea.appendChild(map);
      this.map = map;

      var self = this;
      map.addEventListener('store-map:bounds', function (e) {
        self._onBounds(e.detail.handles || []);
      });
    }

    _onBounds(inView) {
      var self = this;
      var brandsInView = {};
      inView.forEach(function (handle) {
        var card = self._cardByHandle(handle);
        if (!card) return;
        (card.getAttribute('data-brands') || '').split(',').forEach(function (b) {
          if (b) brandsInView[b] = true;
        });
      });
      var items = this._render(inView);
      this._syncFilterOptions(brandsInView);
      if (this.map && this.map.setOrder) {
        this.map.setOrder(
          items.map(function (item) {
            return item.handle;
          })
        );
      }
    }

    // Sort the given handles by distance, apply the brand filter, then show / number /
    // distance them, hide the rest, and update the empty state. Returns the shown items.
    _render(handles) {
      var self = this;
      var items = handles
        .filter(function (handle) {
          if (!self._filter) return true;
          var card = self._cardByHandle(handle);
          if (!card) return false;
          return (card.getAttribute('data-brands') || '').split(',').indexOf(self._filter) !== -1;
        })
        .map(function (handle) {
          var card = self._cardByHandle(handle);
          if (!card) return null;
          return {
            handle: handle,
            card: card,
            distance: self._distanceKm(self._position, {
              lat: parseFloat(card.getAttribute('data-lat')),
              lng: parseFloat(card.getAttribute('data-lng'))
            })
          };
        })
        .filter(Boolean)
        .sort(function (a, b) {
          return a.distance - b.distance;
        });

      this._allCards().forEach(function (card) {
        card.hidden = true;
      });
      items.forEach(function (item, i) {
        item.card.hidden = false;
        self.listEl.appendChild(item.card);
        var num = item.card.querySelector('[data-store-number]');
        if (num) num.textContent = String(i + 1);
        var dist = item.card.querySelector('[data-store-distance]');
        if (dist) {
          dist.textContent = self.distanceTpl.replace('__D__', item.distance.toFixed(2));
          dist.hidden = false;
        }
        self._applyFrom(item.card);
      });

      this.listEl.hidden = items.length === 0;
      this.emptyEl.hidden = items.length > 0;
      return items;
    }

    _syncFilterOptions(brandsInView) {
      if (!this.filterOptions) return;
      var options = this.filterOptions.querySelectorAll('.store-locator__filter-option[data-brand]');
      options.forEach(function (opt) {
        opt.hidden = !brandsInView[opt.getAttribute('data-brand')];
      });
    }

    _applyFrom(card) {
      var from = window.location.pathname + window.location.search;
      var encoded = encodeURIComponent(from);
      ['[data-store-link]', '[data-store-more]'].forEach(function (sel) {
        var link = card.querySelector(sel);
        if (!link) return;
        var base = link.getAttribute('data-href') || link.getAttribute('href');
        if (!base || base === '#') return;
        link.setAttribute('data-href', base);
        var sep = base.indexOf('?') === -1 ? '?' : '&';
        link.setAttribute('href', base + sep + 'from=' + encoded);
      });
    }

    _fetchPredictions(query) {
      var self = this;
      // The debounce is deliberately long (1s), so show the in-field spinner for the
      // whole request rather than leaving the input silent (live parity).
      this._setSearchBusy(true);
      function legacyPredictions(places) {
        return new Promise(function (resolve) {
          if (!places.AutocompleteService) return resolve([]);
          new places.AutocompleteService().getPlacePredictions(
            {
              input: query,
              types: ['(regions)'],
              componentRestrictions: { country: self.country }
            },
            function (preds, status) {
              if (status !== 'OK' || !preds) return resolve([]);
              resolve(
                preds.map(function (p) {
                  return { id: p.place_id, text: p.description };
                })
              );
            }
          );
        });
      }

      window
        .ensureGoogleMaps(this.apiKey, this.mapId)
        .then(function () {
          var places = window.google && window.google.maps && window.google.maps.places;
          if (!places) return [];
          if (places.AutocompleteSuggestion) {
            return places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
              input: query,
              includedRegionCodes: [self.country]
            })
              .then(function (res) {
                return (res.suggestions || []).map(function (s) {
                  return { id: s.placePrediction.placeId, text: s.placePrediction.text.toString() };
                });
              })
              .catch(function () {
                return legacyPredictions(places);
              });
          }
          return legacyPredictions(places);
        })
        .then(function (list) {
          self._setSearchBusy(false);
          self._renderPredictions(list);
        })
        .catch(function () {
          self._setSearchBusy(false);
          self._hidePredictions();
        });
    }

    _setSearchBusy(busy) {
      if (this.spinnerEl) this.spinnerEl.hidden = !busy;
    }

    _renderPredictions(list) {
      this._predictions = list;
      this._activeIndex = -1;
      this.predictionsEl.textContent = '';
      if (!list.length) {
        this._hidePredictions();
        return;
      }
      var self = this;
      list.forEach(function (p, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'store-locator__prediction';
        btn.setAttribute('role', 'option');
        btn.id = 'store-locator-option-' + i;
        btn.setAttribute('aria-selected', 'false');
        btn.tabIndex = -1;
        btn.textContent = p.text;
        btn.addEventListener('click', function () {
          self._select(p);
        });
        self.predictionsEl.appendChild(btn);
      });
      this.predictionsEl.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    _hidePredictions() {
      this._setSearchBusy(false);
      if (!this.predictionsEl) return;
      this.predictionsEl.hidden = true;
      this.predictionsEl.textContent = '';
      this._predictions = [];
      this._activeIndex = -1;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
    }

    _onInputKey(e) {
      if (this.predictionsEl.hidden) return;
      var max = this._predictions.length - 1;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Home' || e.key === 'End') {
        e.preventDefault();
        if (e.key === 'ArrowDown') {
          this._activeIndex = this._activeIndex < 0 ? 0 : Math.min(this._activeIndex + 1, max);
        } else if (e.key === 'ArrowUp') {
          this._activeIndex = this._activeIndex < 0 ? max : Math.max(this._activeIndex - 1, 0);
        } else if (e.key === 'Home') {
          this._activeIndex = 0;
        } else {
          this._activeIndex = max;
        }
        var options = this.predictionsEl.querySelectorAll('[role="option"]');
        options.forEach(function (o, i) {
          o.setAttribute('aria-selected', i === this._activeIndex ? 'true' : 'false');
        });
        var active = options[this._activeIndex];
        if (active) this.input.setAttribute('aria-activedescendant', active.id);
      } else if (e.key === 'Enter') {
        if (this._activeIndex >= 0) {
          e.preventDefault();
          this._select(this._predictions[this._activeIndex]);
        }
      }
    }

    _select(prediction) {
      var self = this;
      this._hidePredictions();
      window
        .ensureGoogleMaps(this.apiKey, this.mapId)
        .then(function () {
          return new window.google.maps.Geocoder().geocode({ placeId: prediction.id });
        })
        .then(function (res) {
          var loc = res.results && res.results[0] && res.results[0].geometry.location;
          if (!loc) return;
          self._setPosition(loc.lat(), loc.lng());
        })
        .catch(function () {
          /* ignore */
        });
    }

    _geolocate() {
      var self = this;
      if (!navigator.geolocation) return;
      this.geoBtn.setAttribute('aria-busy', 'true');
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          self._setPosition(pos.coords.latitude, pos.coords.longitude);
        },
        function () {
          self.geoBtn.setAttribute('aria-busy', 'false');
        },
        { timeout: 10000 }
      );
    }

    _setPosition(lat, lng) {
      var params = new URLSearchParams(window.location.search);
      params.set('position', lat + ',' + lng);
      params.delete('filter');
      window.location.search = params.toString();
    }

    _setFilter(handle) {
      var params = new URLSearchParams(window.location.search);
      if (handle) {
        params.set('filter', handle);
      } else {
        params.delete('filter');
      }
      window.location.search = params.toString();
    }

    _parsePosition(value) {
      if (!value) return null;
      var parts = String(value).split(',');
      if (parts.length !== 2) return null;
      var lat = parseFloat(parts[0]);
      var lng = parseFloat(parts[1]);
      if (isNaN(lat) || isNaN(lng)) return null;
      return { lat: lat, lng: lng };
    }

    _distanceKm(origin, store) {
      var R = 6371;
      var dLat = this._deg2rad(store.lat - origin.lat);
      var dLng = this._deg2rad(store.lng - origin.lng);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this._deg2rad(origin.lat)) * Math.cos(this._deg2rad(store.lat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    _deg2rad(deg) {
      return deg * (Math.PI / 180);
    }

    _cardByHandle(handle) {
      return this.listEl.querySelector('[data-store-card][data-handle="' + this._cssEscape(handle) + '"]');
    }

    _allCards() {
      return Array.prototype.slice.call(this.listEl.querySelectorAll('[data-store-card]'));
    }

    _allHandles() {
      return this._allCards().map(function (card) {
        return card.getAttribute('data-handle');
      });
    }

    _cssEscape(value) {
      return String(value).replace(/["\\]/g, '\\$&');
    }

    _reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
  }

  if (!window.customElements.get('store-locator')) {
    window.customElements.define('store-locator', StoreLocator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
  class DcTabs extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(min-width: 67rem)');
      this.items = Array.from(this.querySelectorAll('[data-tabbed-item]'));
      this.onToggle = this.onToggle.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onMq = this.syncDefault.bind(this);

      this.items.forEach((item) => item.addEventListener('toggle', this.onToggle));
      this.addEventListener('click', this.onClick);
      this.mq.addEventListener('change', this.onMq);

      this.syncDefault();
    }

    disconnectedCallback() {
      if (this.items) {
        this.items.forEach((item) => item.removeEventListener('toggle', this.onToggle));
      }
      this.removeEventListener('click', this.onClick);
      if (this.mq) this.mq.removeEventListener('change', this.onMq);
    }

    firstOpenable() {
      return this.items.find((item) => !item.hasAttribute('data-tc-locked'));
    }

    // Desktop: exactly one strip open (first non-locked). Mobile: all closed.
    syncDefault() {
      if (this.mq.matches) {
        const open = this.items.filter((item) => item.open);
        if (open.length !== 1 || open[0].hasAttribute('data-tc-locked')) {
          this.items.forEach((item) => {
            item.open = false;
          });
          const first = this.firstOpenable();
          if (first) first.open = true;
        }
      } else {
        this.items.forEach((item) => {
          item.open = false;
        });
      }
    }

    // Single-open: when one opens, close the others.
    onToggle(event) {
      const opened = event.target;
      if (!opened.open) return;
      this.items.forEach((item) => {
        if (item !== opened && item.open) item.open = false;
      });
    }

    onClick(event) {
      const item = event.target.closest('[data-tabbed-item]');
      if (!item || !this.contains(item)) return;
      const summary = event.target.closest('summary');

      // Locked tabs never toggle.
      if (item.hasAttribute('data-tc-locked')) {
        if (summary) event.preventDefault();
        return;
      }

      if (this.mq.matches) {
        // Desktop: keep one always open (block closing the active), and let a click
        // anywhere on a collapsed strip activate it.
        if (summary && item.open) {
          event.preventDefault();
          return;
        }
        if (!summary && !item.open) item.open = true;
      }
    }
  }

  if (!window.customElements.get('dc-tabs')) {
    window.customElements.define('dc-tabs', DcTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["table"] && !Shopify.designMode) return;
  try {
    
  class DcTable extends HTMLElement {
    connectedCallback() {
      this.pad();
    }

    /* #303: merchants build ragged tables -- the international shipping table has five
       columns but two three-cell rows. A CSS table gives such a row no box in the missing
       columns, and WebKit will not paint the row's bottom border across that area (Blink
       will), so in Safari the rule stopped at the last real cell. Padding every short row
       out to the table's column count removes the ragged condition itself, so the plain
       border-bottom on .dc-table__row paints edge to edge in every engine -- no reliance
       on how a browser treats missing cells. Fillers are empty cells with role="cell", so
       the ARIA table also becomes rectangular rather than staying jagged. */
    pad() {
      const rows = Array.from(this.querySelectorAll('.dc-table__row'));
      if (!rows.length) return;

      /* Re-entrant: the theme editor re-runs connectedCallback on every section render,
         and a merchant may have added a cell since the last pass. */
      rows.forEach((row) => {
        row.querySelectorAll('.dc-table__cell[data-filler]').forEach((cell) => cell.remove());
      });

      const counts = rows.map((row) => row.querySelectorAll('.dc-table__cell').length);
      const columns = Math.max.apply(null, counts);

      rows.forEach((row, index) => {
        for (let i = counts[index]; i < columns; i++) {
          const filler = document.createElement('div');
          filler.className = 'dc-table__cell';
          filler.setAttribute('role', 'cell');
          filler.setAttribute('data-filler', '');
          row.appendChild(filler);
        }
      });
    }
  }

  if (!window.customElements.get('dc-table')) {
    window.customElements.define('dc-table', DcTable);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-columns"] && !Shopify.designMode) return;
  try {
    
  class TextColumns extends HTMLElement {
    connectedCallback() {
      this.layout();
    }

    layout() {
      const rows = this.querySelectorAll('.text-columns__row');
      rows.forEach((row) => {
        const cols = Array.from(
          row.querySelectorAll('.text-columns__col[data-col-width]')
        );
        if (!cols.length) return;
        const widths = cols.map((col) => parseFloat(col.getAttribute('data-col-width')) || 0);
        const min = Math.min.apply(null, widths);
        if (min > 0 && min < 50) {
          row.style.setProperty('--tc-row-min', String(min));
          row.setAttribute('data-fluid', '');
        } else {
          row.style.removeProperty('--tc-row-min');
          row.removeAttribute('data-fluid');
        }
      });
    }
  }

  if (!window.customElements.get('text-columns')) {
    window.customElements.define('text-columns', TextColumns);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-text"] && !Shopify.designMode) return;
  try {
    
  class VideoText extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('[data-vt-video]'));
      if (!this.videos.length) return;

      // Respect reduced-motion: strip the native autoplay and pause, leaving the poster + controls.
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduceMotion.matches) {
        this.videos.forEach((video) => {
          video.removeAttribute('autoplay');
          video.pause();
        });
        return;
      }

      // Pause autoplaying videos that scroll out of view (and resume them).
      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.play(entry.target);
            } else {
              entry.target.pause();
            }
          });
        },
        { rootMargin: '200px' }
      );

      this.videos.forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    play(video) {
      if (video.offsetParent === null) return;
      const playback = video.play();
      if (playback && playback.catch) playback.catch(() => {});
    }
  }

  if (!window.customElements.get('video-text')) {
    window.customElements.define('video-text', VideoText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  class DcWishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.loadingEl = this.querySelector('[data-wishlist-loading]');
      this.emptyEl = this.querySelector('[data-wishlist-empty]');
      this.cardSection = this.dataset.cardSection || 'wishlist-card';
      this.swymEnabled = this.dataset.swymEnabled === 'true';
      this.concurrency = 6;
      this.rendered = false;
      this.shareBtn = this.querySelector('[data-wishlist-share]');
      // #111: the recommendations band rides the same two state methods as the
      // share button. Absent when Searchspring is inactive for this market.
      this.recsEl = this.querySelector('[data-wishlist-recs]');
      this.listPublic = false;
      this.markPublicPromise = null;
      // #274: live `WishlistLayout` slices the sorted list at 8 per page.
      this.pageSize = 8;
      this.page = 1;
      this.gridVisible = false;
      this.paginationEl = this.querySelector('[data-wishlist-pagination]');
      this.paginator = this.paginationEl ? this.paginationEl.querySelector('dc-pagination') : null;
      this.onPageChange = this.handlePageChange.bind(this);
      if (this.paginator) this.paginator.addEventListener('pagination:change', this.onPageChange);

      this.onItems = this.handleItems.bind(this);
      this.onChange = this.handleChange.bind(this);
      this.onGridClick = this.handleGridClick.bind(this);
      this.onShareClick = this.handleShareClick.bind(this);
      if (this.grid) this.grid.addEventListener('click', this.onGridClick);
      if (this.shareBtn) this.shareBtn.addEventListener('click', this.onShareClick);
      document.addEventListener('wishlist:change', this.onChange);

      this.start();
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:items', this.onItems);
      document.removeEventListener('wishlist:change', this.onChange);
      if (this.grid) this.grid.removeEventListener('click', this.onGridClick);
      if (this.shareBtn) this.shareBtn.removeEventListener('click', this.onShareClick);
      if (this.paginator) this.paginator.removeEventListener('pagination:change', this.onPageChange);
      if (this.fallbackTimer) clearTimeout(this.fallbackTimer);
    }

    start() {
      if (!this.swymEnabled) {
        this.showEmpty();
        return;
      }
      if (window.__dcWishlistReady && Array.isArray(window.__dcWishlistItems)) {
        this.renderItems(window.__dcWishlistItems);
        return;
      }
      document.addEventListener('wishlist:items', this.onItems, { once: true });
      this.fallbackTimer = setTimeout(() => {
        if (!this.rendered) this.showEmpty();
      }, 10000);
    }

    handleItems(e) {
      const items = e && e.detail && Array.isArray(e.detail.items) ? e.detail.items : [];
      this.renderItems(items);
    }

    renderItems(items) {
      if (this.rendered) return;
      this.rendered = true;
      if (this.fallbackTimer) {
        clearTimeout(this.fallbackTimer);
        this.fallbackTimer = null;
      }
      const list = (Array.isArray(items) ? items : []).filter((item) => item && item.handle);
      if (!list.length) {
        this.showEmpty();
        return;
      }
      list.sort((a, b) => String(a.title).localeCompare(String(b.title)));

      const slots = list.map((item) => {
        const li = document.createElement('li');
        li.className = 'wishlist__item';
        li.setAttribute('data-variant-id', item.variantId);
        this.grid.appendChild(li);
        return { item: item, slot: li };
      });

      // #274: hide the off-page slots up front, hydrate the visible page first
      // so the grid can show as soon as it is ready, then fill the remaining
      // pages behind it (they stay hidden until paged to).
      this.applyPage();
      const firstPage = slots.slice(0, this.pageSize);
      const rest = slots.slice(this.pageSize);
      this.hydrate(firstPage)
        .then(() => {
          if (this.grid.children.length > 0) this.showGrid();
          else this.showEmpty();
          return this.hydrate(rest);
        })
        .then(() => {
          if (this.rendered && this.grid.children.length === 0) this.showEmpty();
        });
    }

    hydrate(slots) {
      let index = 0;
      const self = this;
      const worker = () => {
        if (index >= slots.length) return Promise.resolve();
        const current = slots[index++];
        return self.fetchCard(current.item, current.slot).then(worker);
      };
      const runners = [];
      const count = Math.min(this.concurrency, slots.length);
      for (let i = 0; i < count; i++) runners.push(worker());
      return Promise.all(runners);
    }

    fetchCard(item, slot) {
      // Pass the saved variant so the card's selected_or_first_available_variant
      // resolves to it -- seeds the pre-selected quick-shop size + the heart id.
      let url = '/products/' + encodeURIComponent(item.handle) + '?section_id=' + encodeURIComponent(this.cardSection);
      if (item.variantId) url += '&variant=' + encodeURIComponent(item.variantId);
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then((res) => (res.ok ? res.text() : ''))
        .then((html) => {
          const markup = html ? html.trim() : '';
          if (!markup) {
            this.removeSlot(slot);
            return;
          }
          slot.innerHTML = markup;
          this.markSaved(slot, item);
        })
        .catch(() => this.removeSlot(slot));
    }

    markSaved(slot, item) {
      const wrapper = slot.querySelector('.wishlist-button');
      const btn = slot.querySelector('.wishlist-button__btn');
      if (wrapper) wrapper.classList.add('is-saved');
      if (btn) {
        btn.setAttribute('aria-pressed', 'true');
        const removeLabel = wrapper && wrapper.dataset ? wrapper.dataset.labelRemove : '';
        if (removeLabel) btn.setAttribute('aria-label', removeLabel);
      }
    }

    // Scoped to the grid container (#111): with dc-wishlist-button registered on
    // this page for the rail cards, a rail heart owns its own toggle and must
    // never reach this delegated remove path. Grid hearts upgrade too and stop
    // propagation at the button, so this now only runs for a heart that never
    // upgraded -- the pre-#111 fallback, unchanged.
    handleGridClick(e) {
      const btn = e.target.closest('.wishlist-button__btn');
      if (!btn) return;
      if (btn.closest('[data-wishlist-grid]') !== this.grid) return;
      e.preventDefault();
      e.stopPropagation();
      const wrapper = btn.closest('.wishlist-button');
      const slot = btn.closest('.wishlist__item');
      if (!wrapper || !slot) return;
      const swat = window._swat;
      if (!swat) return;
      const rawUrl = wrapper.dataset.productUrl;
      const product = {
        empi: parseInt(wrapper.dataset.productId, 10),
        epi: parseInt(wrapper.dataset.variantId, 10),
        // Swym requires an absolute destination URL; the card carries a relative one.
        du: rawUrl ? new URL(rawUrl, window.location.origin).href : rawUrl,
      };
      const removeFn = swat.removeFromWishList || swat.deleteFromWishList;
      if (typeof removeFn !== 'function') return;
      const self = this;
      slot.classList.add('wishlist__item--pending');
      try {
        removeFn.call(
          swat,
          product,
          function () {
            self.broadcastRemoved(product.empi, product.epi);
            // #214: removal feedback toast, matching the heart's own remove path
            // (injected hearts are inert here -- this delegated handler owns it).
            if (self.dataset.labelRemoved) {
              document.dispatchEvent(
                new CustomEvent('toast:show', { detail: { text: self.dataset.labelRemoved, icon: 'tick' } })
              );
            }
          },
          function () {
            slot.classList.remove('wishlist__item--pending');
            // #214: removal-failure feedback, matching the heart's remove path.
            if (self.dataset.labelRemoveFailed) {
              document.dispatchEvent(
                new CustomEvent('toast:show', { detail: { text: self.dataset.labelRemoveFailed } })
              );
            }
          }
        );
      } catch (err) {
        slot.classList.remove('wishlist__item--pending');
      }
    }

    broadcastRemoved(productId, variantId) {
      document.dispatchEvent(
        new CustomEvent('wishlist:change', {
          detail: { productId: productId, variantId: variantId, added: false },
        })
      );
    }

    handleChange(e) {
      const detail = e && e.detail;
      if (!detail || detail.added !== false) return;
      const variantId = parseInt(detail.variantId, 10);
      if (Number.isNaN(variantId)) return;
      const slot = this.grid.querySelector('[data-variant-id="' + variantId + '"]');
      if (slot) slot.remove();
      this.applyPage();
      if (this.rendered && this.grid.children.length === 0) this.showEmpty();
    }

    // #274: one page of tiles at a time. Slots stay in the DOM in sorted order
    // and the off-page ones are `hidden`, so a removal on any page reflows the
    // rest for free. Deviation from live: the current page clamps to the last
    // page when removals shrink the list (live keeps the stale page number and
    // renders an empty grid until the shopper pages back).
    applyPage() {
      if (!this.grid) return;
      const slots = Array.prototype.slice.call(this.grid.children);
      const total = Math.ceil(slots.length / this.pageSize);
      if (this.page > total) this.page = Math.max(1, total);
      if (this.page < 1) this.page = 1;
      const start = (this.page - 1) * this.pageSize;
      const end = start + this.pageSize;
      slots.forEach((slot, i) => {
        slot.hidden = i < start || i >= end;
      });
      if (this.paginator) {
        this.paginator.setAttribute('total-pages', String(total));
        this.paginator.setAttribute('current-page', String(this.page));
      }
      if (this.paginationEl) this.paginationEl.hidden = !this.gridVisible || total <= 1;
    }

    handlePageChange(e) {
      const page = e && e.detail ? parseInt(e.detail.page, 10) : NaN;
      if (Number.isNaN(page) || page === this.page) return;
      this.page = page;
      this.applyPage();
      // Live: window.scrollTo({ top: 0, behavior: 'smooth' }) on every page change.
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    showGrid() {
      if (this.loadingEl) this.loadingEl.hidden = true;
      if (this.emptyEl) this.emptyEl.hidden = true;
      if (this.grid) this.grid.hidden = false;
      if (this.shareBtn) this.shareBtn.hidden = false;
      if (this.recsEl) this.recsEl.hidden = false;
      this.gridVisible = true;
      this.applyPage();
    }

    showEmpty() {
      if (this.loadingEl) this.loadingEl.hidden = true;
      if (this.grid) this.grid.hidden = true;
      if (this.emptyEl) this.emptyEl.hidden = false;
      if (this.shareBtn) this.shareBtn.hidden = true;
      if (this.recsEl) this.recsEl.hidden = true;
      this.gridVisible = false;
      if (this.paginationEl) this.paginationEl.hidden = true;
    }

    // Share intent (#137): mark the list public once (lazily - live marks on
    // every page load), then open the share dialog. Failure toasts and leaves
    // the button enabled for retry.
    handleShareClick() {
      const self = this;
      const trigger = this.shareBtn;
      this.ensurePublic().then(function (ok) {
        if (ok) {
          document.dispatchEvent(new CustomEvent('wishlist:share-open', { detail: { trigger: trigger } }));
        } else if (self.dataset.labelShareFailed) {
          document.dispatchEvent(
            new CustomEvent('toast:show', { detail: { text: self.dataset.labelShareFailed } })
          );
        }
      });
    }

    ensurePublic() {
      if (this.listPublic) return Promise.resolve(true);
      if (this.markPublicPromise) return this.markPublicPromise;
      const creds = window.__dcWishlistCreds;
      const lid = window.__dcWishlistListId;
      if (!creds || !creds.host || !creds.pid || !creds.regid || !creds.sessionid || !lid) {
        return Promise.resolve(false);
      }
      const self = this;
      const url = creds.host + '/api/v3/lists/markPublic?pid=' + encodeURIComponent(creds.pid);
      const body = new URLSearchParams();
      body.set('regid', creds.regid);
      body.set('sessionid', creds.sessionid);
      body.set('lid', lid);
      this.markPublicPromise = fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: body.toString(),
      })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (data) {
          const ok = !!(data && data.lid);
          self.listPublic = ok;
          if (!ok) self.markPublicPromise = null;
          return ok;
        })
        .catch(function () {
          self.markPublicPromise = null;
          return false;
        });
      return this.markPublicPromise;
    }

    removeSlot(slot) {
      if (slot && slot.parentNode) slot.parentNode.removeChild(slot);
      this.applyPage();
    }
  }

  if (!window.customElements.get('dc-wishlist-page')) {
    window.customElements.define('dc-wishlist-page', DcWishlistPage);
  }

  } catch(e) { console.error(e); }
})();
})();
